/**
 * Ruleta de descuentos — spin-wheel.js
 * Campanas desde metaobjetos Shopify (spin_wheel_campaign).
 */
(function () {
  'use strict';

  var STORAGE_PREFIX = 'krono-spin-wheel-';
  var MSG_COPIED = '\u00A1Copiado!';
  var MSG_MAX_SPINS = 'Ya alcanzaste el m\u00E1ximo de participaciones.';
  var MSG_ALREADY_SUB_A = 'ya est\u00E1 suscrito';
  var MSG_CF_VERIFY = 'Verificando la conexi\u00F3n';
  var MSG_GIFT_ADDING = 'A\u00F1adiendo tu obsequio al carrito\u2026';
  var MSG_GIFT_ADDED = 'Obsequio a\u00F1adido al carrito.';
  var MSG_GIFT_ALREADY = 'Tu obsequio ya est\u00E1 en el carrito.';
  var MSG_GIFT_ERROR = 'No pudimos a\u00F1adir el obsequio. Intenta de nuevo o usa el cup\u00F3n.';
  var MSG_SPINNING = 'Girando\u2026';
  var MSG_REGISTERING = 'Registrando\u2026';
  var MSG_LEDGER_SPIN_ERROR =
    'No pudimos sortear tu premio. Intenta de nuevo en unos segundos.';
  var MSG_LEDGER_SESSION_MISSING =
    'Registra tu factura primero para participar en esta ruleta.';
  var MSG_TAG_CAMPAIGN_ERROR =
    'No pudimos asociarte a la campa\u00F1a. Intenta de nuevo en unos minutos.';
  var MSG_COUPON_ASSIGN_ERROR =
    'No pudimos generar tu cup\u00F3n \u00FAnico. Intenta de nuevo en unos minutos.';
  var MSG_COUPON_LOADING = 'Generando cup\u00F3n\u2026';
  var ORDER_ID_STORAGE_PREFIX = STORAGE_PREFIX + 'order-';
  var ORDER_TOTAL_STORAGE_PREFIX = STORAGE_PREFIX + 'order-total-';
  var GIFT_SESSION_PREFIX = STORAGE_PREFIX + 'gift-added-';
  var GIFT_LINE_PROPERTY = '_spin_wheel_gift';
  var COUNTDOWN_STORAGE_PREFIX = STORAGE_PREFIX + 'countdown-';
  var SESSION_TOKEN_PREFIX = STORAGE_PREFIX + 'session-';
  var MSG_GIFT_ONLY_CHECKOUT =
    'Agrega al menos otro producto para continuar. El obsequio de la ruleta no se puede llevar solo al checkout.';

  function countdownStorageKey(campaignId) {
    return COUNTDOWN_STORAGE_PREFIX + String(campaignId || 'default');
  }

  function readCountdownState(campaignId) {
    try {
      var raw = localStorage.getItem(countdownStorageKey(campaignId));
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.endsAt) return null;
      return parsed;
    } catch (err) {
      return null;
    }
  }

  function writeCountdownState(campaignId, state) {
    try {
      localStorage.setItem(countdownStorageKey(campaignId), JSON.stringify(state));
    } catch (err) {
      /* private mode */
    }
  }

  function clearCountdownState(campaignId) {
    try {
      localStorage.removeItem(countdownStorageKey(campaignId));
    } catch (err) {
      /* ignore */
    }
  }

  function clearAllCountdownStates() {
    try {
      var toRemove = [];
      for (var i = 0; i < localStorage.length; i++) {
        var key = localStorage.key(i);
        if (key && key.indexOf(COUNTDOWN_STORAGE_PREFIX) === 0) toRemove.push(key);
      }
      for (var j = 0; j < toRemove.length; j++) {
        localStorage.removeItem(toRemove[j]);
      }
    } catch (err) {
      /* ignore */
    }
  }

  function pad2(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function formatCountdown(msLeft, format) {
    var totalSec = Math.max(0, Math.ceil(msLeft / 1000));
    var hours = Math.floor(totalSec / 3600);
    var mins = Math.floor((totalSec % 3600) / 60);
    var secs = totalSec % 60;
    if (format === 'hh:mm:ss' || hours > 0) {
      return pad2(hours) + ':' + pad2(mins) + ':' + pad2(secs);
    }
    var totalMins = Math.floor(totalSec / 60);
    return pad2(totalMins) + ':' + pad2(secs);
  }

  function isRealPrize(prize) {
    if (!prize) return false;
    if (isGiftPrize(prize)) return true;
    if (hasDiscountCode(prize)) return true;
    return false;
  }

  function sortPrizes(prizes) {
    return (prizes || []).slice().sort(function (a, b) {
      var ao = parseInt(a && (a.order != null ? a.order : a.sort_order), 10);
      var bo = parseInt(b && (b.order != null ? b.order : b.sort_order), 10);
      if (isNaN(ao) && isNaN(bo)) return 0;
      if (isNaN(ao)) return 1;
      if (isNaN(bo)) return -1;
      if (ao !== bo) return ao - bo;
      return 0;
    });
  }

  function parseJson(el, fallback) {
    if (!el) return fallback;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return fallback;
    }
  }

  function getStorageKey(campaignId, suffix) {
    return STORAGE_PREFIX + campaignId + '-' + suffix;
  }

  function readStorage(key) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function writeStorage(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (e) {
      /* quota / private mode */
    }
  }

  function clearStorage(key) {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      /* quota / private mode */
    }
  }

  function normalizePathname(path) {
    var p = String(path || '/')
      .toLowerCase()
      .split('?')[0]
      .split('#')[0]
      .trim();
    if (!p) p = '/';
    if (p.length > 1 && p.charAt(p.length - 1) === '/') {
      p = p.slice(0, -1);
    }
    return p;
  }

  function pathMatchesRoute(path, rawTarget) {
    var current = normalizePathname(path);
    var target = normalizePathname(rawTarget);
    if (!target) return false;
    if (target === '/') return current === '/';
    if (current === target) return true;
    if (current.indexOf(target + '/') === 0) return true;
    /* Markets / locale: /es/pages/foo */
    if (current.indexOf(target) !== -1) return true;
    return false;
  }

  function matchesScope(root) {
    var path = normalizePathname(window.location.pathname);
    var excluded = parseJson(root.querySelector('[data-spin-wheel-exclude-urls]'), []);
    for (var e = 0; e < excluded.length; e++) {
      if (pathMatchesRoute(path, excluded[e])) return false;
    }

    var mode = (root.dataset.scopeMode || 'all_store').toLowerCase();
    if (mode === 'all_store') return true;

    var template = (root.dataset.template || '').toLowerCase();
    var templates = parseJson(root.querySelector('[data-spin-wheel-target-templates]'), []);
    var urls = parseJson(root.querySelector('[data-spin-wheel-target-urls]'), []);

    for (var i = 0; i < templates.length; i++) {
      if (String(templates[i]).toLowerCase().trim() === template) return true;
    }

    for (var j = 0; j < urls.length; j++) {
      if (pathMatchesRoute(path, urls[j])) return true;
    }

    return false;
  }

  function isDismissed(root) {
    var key = getStorageKey(root.dataset.campaignId, 'dismissed-at');
    var dismissedAt = readStorage(key);
    if (!dismissedAt) return false;

    var hours = parseInt(root.dataset.cooldownHours, 10);
    if (isNaN(hours)) hours = 24;
    var elapsed = Date.now() - parseInt(dismissedAt, 10);
    return elapsed < hours * 3600000;
  }

  function getSpinCount(root) {
    var key = getStorageKey(root.dataset.campaignId, 'spin-count');
    return parseInt(readStorage(key) || '0', 10);
  }

  function incrementSpinCount(root) {
    var key = getStorageKey(root.dataset.campaignId, 'spin-count');
    var count = getSpinCount(root) + 1;
    writeStorage(key, String(count));
    return count;
  }

  function canSpinAgain(root) {
    var max = parseInt(root.dataset.maxSpins, 10);
    if (max === 0) return true;
    return getSpinCount(root) < max;
  }

  /**
   * Tiendas (asesor, mismo dispositivo): cada factura nueva = presupuesto de
   * intentos fresco en el browser. El tope real sigue siendo MAX_ATTEMPTS
   * por session_token en Apps Script.
   */
  function resetClientSpinBudget(root) {
    if (!root) return;
    var id = root.dataset.campaignId;
    clearStorage(getStorageKey(id, 'spin-count'));
    clearStorage(getStorageKey(id, 'dismissed-at'));
  }

  function setDismissed(root) {
    writeStorage(getStorageKey(root.dataset.campaignId, 'dismissed-at'), String(Date.now()));
  }

  function stripHtml(text) {
    return text.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function parseKnownCustomerError(errorText) {
    var lowerError = (errorText || '').toLowerCase();

    var existingPatterns = [
      'already been taken',
      'already subscribed',
      MSG_ALREADY_SUB_A,
      'ya esta suscrito',
      'has already been',
      'ya se ha suscrito'
    ];

    for (var i = 0; i < existingPatterns.length; i++) {
      if (lowerError.indexOf(existingPatterns[i]) !== -1) {
        return { ok: true, existing: true };
      }
    }

    return {
      ok: false,
      message: errorText || 'No se pudo registrar el email. Intenta de nuevo.'
    };
  }

  function inspectCustomerForm(doc, formId) {
    if (!doc) return null;

    function checkForm(formEl) {
      if (!formEl) return null;

      if (formEl.querySelector('[data-spin-wheel-subscribe-success]')) {
        return { ok: true };
      }

      var errorNode = formEl.querySelector('[data-spin-wheel-subscribe-error]');
      if (errorNode) {
        var errorResult = parseKnownCustomerError(stripHtml(errorNode.innerHTML));
        if (errorResult.ok) return errorResult;
        return { ok: false, definiteError: true, message: errorResult.message };
      }

      var visibleError = formEl.querySelector(
        '.site-footer__newsletter-error, .form-message--error, .input-error-message'
      );
      if (visibleError) {
        var visibleErrorText = stripHtml(visibleError.textContent || visibleError.innerHTML);
        if (visibleErrorText.length > 2) {
          var visibleResult = parseKnownCustomerError(visibleErrorText);
          if (visibleResult.ok) return visibleResult;
          return { ok: false, definiteError: true, message: visibleResult.message };
        }
      }

      var successEl = formEl.querySelector('.form-message--success, .note.form-success');
      if (successEl) {
        var successText = stripHtml(successEl.textContent || successEl.innerHTML);
        if (successText.length > 2) {
          return { ok: true };
        }
      }

      return null;
    }

    var spinForm = formId ? doc.getElementById(formId) : null;
    var spinResult = checkForm(spinForm);
    if (spinResult) return spinResult;

    return checkForm(doc.getElementById('ContactFooter'));
  }

  function isCloudflareChallenge(html) {
    return (
      html.indexOf('Verifying your connection') !== -1 ||
      html.indexOf(MSG_CF_VERIFY) !== -1 ||
      html.indexOf('challenge-error-text') !== -1
    );
  }

  function looksLikeSuccessfulStorefrontResponse(doc, formId, html) {
    if (!doc || !html || html.length < 1500) return false;
    if (isCloudflareChallenge(html)) return false;

    var parsed = inspectCustomerForm(doc, formId);
    if (parsed && parsed.definiteError) return false;
    if (parsed && parsed.ok) return true;

    // Solo éxito con evidencia real. Antes devolvía true si el HTML
    // de la tienda existía → giro sin crear el customer/suscriptor.
    if (
      html.indexOf('data-spin-wheel-subscribe-success') !== -1 ||
      html.indexOf('posted_successfully') !== -1 ||
      html.indexOf('form-message--success') !== -1 ||
      html.indexOf('newsletter_confirmation') !== -1 ||
      html.indexOf('form-success') !== -1
    ) {
      return true;
    }

    var lower = html.toLowerCase();
    if (
      lower.indexOf('already been taken') !== -1 ||
      lower.indexOf('already subscribed') !== -1 ||
      lower.indexOf(MSG_ALREADY_SUB_A) !== -1 ||
      lower.indexOf('ya esta suscrito') !== -1 ||
      lower.indexOf('has already been') !== -1 ||
      lower.indexOf('ya se ha suscrito') !== -1
    ) {
      return true;
    }

    return false;
  }

  function prizeWeight(prize) {
    return Math.max(1, parseInt(prize && prize.weight, 10) || 1);
  }

  function prizeSliceWidth(prize) {
    if (!prize || prize.width == null || prize.width === '') return null;
    var w = parseInt(prize.width, 10);
    if (isNaN(w) || w < 1) return null;
    return w;
  }

  function pickWeightedIndex(prizes) {
    var total = 0;
    for (var i = 0; i < prizes.length; i++) {
      total += prizeWeight(prizes[i]);
    }
    var rand = Math.random() * total;
    for (var j = 0; j < prizes.length; j++) {
      rand -= prizeWeight(prizes[j]);
      if (rand <= 0) return j;
    }
    return prizes.length - 1;
  }

  function sessionTokenKey(campaignId) {
    return SESSION_TOKEN_PREFIX + String(campaignId || 'default');
  }

  function readSessionToken(campaignId) {
    try {
      var fromStorage = sessionStorage.getItem(sessionTokenKey(campaignId));
      if (fromStorage) return fromStorage;
    } catch (err) {
      /* private mode */
    }
    try {
      var params = new URLSearchParams(window.location.search);
      var fromUrl =
        params.get('sw_session') ||
        params.get('session_token') ||
        params.get('sessionToken');
      if (fromUrl) {
        writeSessionToken(campaignId, fromUrl);
        return fromUrl;
      }
    } catch (err2) {
      /* ignore */
    }
    return '';
  }

  function writeSessionToken(campaignId, token) {
    if (!token) return;
    try {
      sessionStorage.setItem(sessionTokenKey(campaignId), String(token));
    } catch (err) {
      /* private mode */
    }
  }

  function orderIdStorageKey(campaignId) {
    return ORDER_ID_STORAGE_PREFIX + String(campaignId || 'default');
  }

  function sanitizeOrderId(raw) {
    var id = String(raw || '')
      .trim()
      .toUpperCase()
      .replace(/[^A-Z0-9#_-]/g, '')
      .slice(0, 40);
    /* TC25218 → TC_25218 (nombre de orden Shopify). */
    if (id && id.indexOf('_') < 0 && /^[A-Z]+\d+$/.test(id)) {
      id = id.replace(/^([A-Z]+)(\d+)$/, '$1_$2');
    }
    return id;
  }

  /** type de cupón = discount_code del metaobjeto (ej. "Ruleta - Bono 100K"). */
  function sanitizeCouponType(raw) {
    var type = String(raw || '')
      .trim()
      .replace(/[\u0000-\u001f\u007f]/g, '')
      .replace(/\s+/g, ' ')
      .slice(0, 80);
    if (!type || type === '—' || type.toUpperCase() === 'NONE' || type.toUpperCase() === 'TRY_AGAIN') {
      return '';
    }
    return type;
  }

  function writeOrderId(campaignId, orderId) {
    var id = sanitizeOrderId(orderId);
    if (!id) return;
    try {
      sessionStorage.setItem(orderIdStorageKey(campaignId), id);
    } catch (err) {
      /* private mode */
    }
  }

  function readOrderId(campaignId) {
    try {
      return sanitizeOrderId(sessionStorage.getItem(orderIdStorageKey(campaignId)));
    } catch (err) {
      return '';
    }
  }

  function orderTotalStorageKey(campaignId) {
    return ORDER_TOTAL_STORAGE_PREFIX + String(campaignId || 'default');
  }

  function writeOrderTotal(campaignId, centavos) {
    var n = Number(centavos);
    if (!Number.isFinite(n) || n < 1) return;
    try {
      sessionStorage.setItem(orderTotalStorageKey(campaignId), String(Math.round(n)));
    } catch (err) {
      /* private mode */
    }
  }

  function readOrderTotal(campaignId) {
    try {
      var n = Number(sessionStorage.getItem(orderTotalStorageKey(campaignId)));
      return Number.isFinite(n) && n > 0 ? n : 0;
    } catch (err) {
      return 0;
    }
  }

  function extractCouponCodeFromResponse(data) {
    if (!data || typeof data !== 'object') return '';
    if (data.success === false) return '';
    /* H2 real: { success:true, coupon:{ code:"SNVCJQZK", title, type } } */
    var nested =
      data.coupon && typeof data.coupon === 'object' ? data.coupon : null;
    var candidates = [
      nested && nested.code,
      nested && nested.couponCode,
      typeof data.coupon === 'string' ? data.coupon : '',
      data.code,
      data.couponCode,
      data.coupon_code,
      data.discountCode,
      data.discount_code,
      data.data && data.data.code,
      data.data && data.data.coupon && data.data.coupon.code,
      data.data && data.data.couponCode
    ];
    for (var i = 0; i < candidates.length; i++) {
      var c = String(candidates[i] || '').trim();
      if (c && c !== '—') return c.slice(0, 64);
    }
    return '';
  }

  function findPrizeIndexByKey(prizes, prizeKey) {
    var key = String(prizeKey || '')
      .trim()
      .toUpperCase();
    if (!key) return -1;
    for (var i = 0; i < prizes.length; i++) {
      var p = prizes[i];
      var pk = String((p && p.prize_key) || '')
        .trim()
        .toUpperCase();
      if (pk && pk === key) return i;
      var code = String((p && p.discount_code) || '')
        .trim()
        .toUpperCase();
      if (code && code === key) return i;
      if (key === 'TRY_AGAIN' && isTryAgainPrize(p)) return i;
    }
    return -1;
  }

  function mergeServerPrize(localPrize, serverPayload) {
    var base = localPrize ? Object.assign({}, localPrize) : {};
    /* type H2 = discount_code del metaobjeto (ej. "Ruleta - Bono 100K"), no lo del AS. */
    var liquidType = sanitizeCouponType(localPrize && localPrize.discount_code);
    if (liquidType) base.coupon_type = liquidType;
    else if (!base.coupon_type) {
      base.coupon_type = sanitizeCouponType(base.discount_code);
    }
    if (!serverPayload) return base;
    if (serverPayload.prize_key) base.prize_key = serverPayload.prize_key;
    if (serverPayload.label) base.label = serverPayload.label;
    if (serverPayload.discount_code != null && serverPayload.discount_code !== '') {
      /* No pisar coupon_type del metaobjeto; solo rellenar si faltaba. */
      if (!base.coupon_type) {
        base.coupon_type = sanitizeCouponType(serverPayload.discount_code);
      }
      base.discount_code = serverPayload.discount_code;
    }
    if (typeof serverPayload.is_try_again === 'boolean') {
      base.is_try_again = serverPayload.is_try_again;
      if (serverPayload.is_try_again) {
        base.discount_code = '';
        base.coupon_type = '';
        base.is_gift = false;
      }
    }
    /* Para UI de premio: si hay type de cupón único, cuenta como premio con código. */
    if (base.coupon_type && !sanitizeCouponType(base.discount_code)) {
      base.discount_code = base.coupon_type;
    }
    return base;
  }

  function promoApiUrl(base, path) {
    var root = String(base || '').replace(/\/+$/, '');
    var suffix = String(path || '').replace(/^\/+/, '');
    return root + '/' + suffix;
  }

  function hasDiscountCode(prize) {
    var code = String((prize && prize.discount_code) || '').trim();
    if (!code || code === '—') return false;
    var upper = code.toUpperCase();
    return upper !== 'NONE' && upper !== 'TRY_AGAIN';
  }

  function isGiftPrize(prize) {
    if (!prize) return false;
    if (prize.is_gift === true) return true;
    var variantId = parseInt(prize.gift_variant_id, 10);
    return !isNaN(variantId) && variantId > 0;
  }

  function isTryAgainPrize(prize) {
    if (!prize) return false;
    if (isGiftPrize(prize)) return false;
    if (prize.is_try_again === true) return true;
    return !hasDiscountCode(prize);
  }

  function giftVariantId(prize) {
    var id = parseInt(prize && prize.gift_variant_id, 10);
    return !isNaN(id) && id > 0 ? id : null;
  }

  function normalizeColor(color) {
    if (color && typeof color === 'object') {
      if (color.hex) return normalizeColor(color.hex);
      if (color.to_hex) return normalizeColor(color.to_hex);
      if (color.red !== undefined && color.green !== undefined && color.blue !== undefined) {
        var r = color.red;
        var g = color.green;
        var b = color.blue;
        if (r <= 1 && g <= 1 && b <= 1) {
          r = Math.round(r * 255);
          g = Math.round(g * 255);
          b = Math.round(b * 255);
        }
        return (
          '#' +
          [r, g, b]
            .map(function (n) {
              var h = Math.max(0, Math.min(255, parseInt(n, 10) || 0)).toString(16);
              return h.length === 1 ? '0' + h : h;
            })
            .join('')
        );
      }
      return '#4663a8';
    }

    var raw = String(color || '').trim();
    if (!raw) return '#4663a8';
    if (raw.indexOf('rgb') === 0 || raw.indexOf('hsl') === 0) return raw;
    if (raw.charAt(0) !== '#') raw = '#' + raw;
    if (/^#[0-9a-fA-F]{8}$/.test(raw)) return raw.slice(0, 7);
    if (/^#[0-9a-fA-F]{3}$/.test(raw) || /^#[0-9a-fA-F]{6}$/.test(raw)) return raw;
    return '#4663a8';
  }

  /**
   * Geometría visual: width controla el arco; si no hay width → trozos iguales.
   * weight NO entra aquí (solo probabilidad).
   * centersFromTop: grados clockwise desde las 12 (puntero).
   */
  function getSegmentGeometry(prizes) {
    var n = prizes.length;
    var widths = [];
    var anyCustom = false;
    var i;

    for (i = 0; i < n; i++) {
      var w = prizeSliceWidth(prizes[i]);
      if (w == null) {
        widths.push(1);
      } else {
        widths.push(w);
        anyCustom = true;
      }
    }

    if (!anyCustom) {
      for (i = 0; i < n; i++) widths[i] = 1;
    }

    var total = 0;
    for (i = 0; i < n; i++) total += widths[i];

    var angles = [];
    var starts = [];
    var centers = [];
    var cursor = 0;
    for (i = 0; i < n; i++) {
      var angle = (widths[i] / total) * 360;
      angles.push(angle);
      starts.push(cursor);
      centers.push(cursor + angle / 2);
      cursor += angle;
    }

    /* Primer trozo centrado bajo el puntero. */
    var fromAngle = -90 - angles[0] / 2;
    var centersFromTop = [];
    for (i = 0; i < n; i++) {
      centersFromTop.push(centers[i] - angles[0] / 2);
    }

    return {
      angles: angles,
      starts: starts,
      centers: centers,
      centersFromTop: centersFromTop,
      fromAngle: fromAngle
    };
  }

  function contrastLabelColor(hex) {
    var raw = normalizeColor(hex).replace('#', '');
    if (raw.length === 3) {
      raw = raw[0] + raw[0] + raw[1] + raw[1] + raw[2] + raw[2];
    }
    if (raw.length !== 6) return '#ffffff';
    var r = parseInt(raw.slice(0, 2), 16);
    var g = parseInt(raw.slice(2, 4), 16);
    var b = parseInt(raw.slice(4, 6), 16);
    if (isNaN(r) || isNaN(g) || isNaN(b)) return '#ffffff';
    var luma = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luma > 0.55 ? '#18233C' : '#ffffff';
  }

  /**
   * Pinta color + texto juntos en SVG (mismo arco) para que no se desalineen.
   */
  function paintWheel(disc, labelsEl, prizes) {
    if (!disc || !prizes || prizes.length < 2) return;

    var geo = getSegmentGeometry(prizes);
    var size = disc.offsetWidth || disc.clientWidth || 280;
    if (size < 40) size = 280;

    var cx = size / 2;
    var cy = size / 2;
    var r = size / 2 - 1;
    var ns = 'http://www.w3.org/2000/svg';

    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 ' + size + ' ' + size);
    svg.setAttribute('width', '100%');
    svg.setAttribute('height', '100%');
    svg.setAttribute('aria-hidden', 'true');
    svg.classList.add('spin-wheel-svg');

    /* Y hacia abajo: ángulo 0 = 3 en punto; -PI/2 = arriba. Sentido horario = +. */
    var cursor = -Math.PI / 2 - (geo.angles[0] / 2) * (Math.PI / 180);

    for (var i = 0; i < prizes.length; i++) {
      var sweep = geo.angles[i] * (Math.PI / 180);
      var a0 = cursor;
      var a1 = cursor + sweep;
      var mid = (a0 + a1) / 2;
      var color = normalizeColor(prizes[i].color);

      var x0 = cx + r * Math.cos(a0);
      var y0 = cy + r * Math.sin(a0);
      var x1 = cx + r * Math.cos(a1);
      var y1 = cy + r * Math.sin(a1);
      var large = sweep > Math.PI ? 1 : 0;
      var d =
        'M ' +
        cx +
        ' ' +
        cy +
        ' L ' +
        x0 +
        ' ' +
        y0 +
        ' A ' +
        r +
        ' ' +
        r +
        ' 0 ' +
        large +
        ' 1 ' +
        x1 +
        ' ' +
        y1 +
        ' Z';

      var path = document.createElementNS(ns, 'path');
      path.setAttribute('d', d);
      path.setAttribute('fill', color);
      path.setAttribute('stroke', 'rgba(0,0,0,0.06)');
      path.setAttribute('stroke-width', '1');
      svg.appendChild(path);

      var tr = r * 0.62;
      var tx = cx + tr * Math.cos(mid);
      var ty = cy + tr * Math.sin(mid);
      var sliceDeg = geo.angles[i];
      var fontSize = sliceDeg < 40 ? 10 : sliceDeg < 55 ? 11 : 13;
      var maxChars = Math.max(6, Math.floor(sliceDeg / 8));

      var label = String(prizes[i].label || '');
      var text = document.createElementNS(ns, 'text');
      text.setAttribute('x', String(tx));
      text.setAttribute('y', String(ty));
      text.setAttribute('text-anchor', 'middle');
      text.setAttribute('dominant-baseline', 'middle');
      text.setAttribute('fill', contrastLabelColor(color));
      text.setAttribute('font-size', String(fontSize));
      text.setAttribute('font-weight', '700');
      text.style.fontFamily = 'inherit';
      /* Horizontal (paralelo a la base de la pantalla), centrado en el trozo. */

      if (label.length > maxChars && label.indexOf(' ') !== -1) {
        var parts = label.split(/\s+/);
        var midWord = Math.ceil(parts.length / 2);
        var line1 = parts.slice(0, midWord).join(' ');
        var line2 = parts.slice(midWord).join(' ');
        var tspan1 = document.createElementNS(ns, 'tspan');
        tspan1.setAttribute('x', String(tx));
        tspan1.setAttribute('dy', '-0.55em');
        tspan1.textContent = line1;
        var tspan2 = document.createElementNS(ns, 'tspan');
        tspan2.setAttribute('x', String(tx));
        tspan2.setAttribute('dy', '1.15em');
        tspan2.textContent = line2;
        text.appendChild(tspan1);
        text.appendChild(tspan2);
      } else {
        text.textContent = label;
      }

      svg.appendChild(text);
      cursor = a1;
    }

    disc.style.background = 'none';
    disc.innerHTML = '';
    disc.appendChild(svg);

    if (labelsEl) {
      labelsEl.innerHTML = '';
      labelsEl.hidden = true;
    }
  }

  function calcSpinRotation(prizeIndex, prizes) {
    var geo = getSegmentGeometry(prizes);
    var segmentCenter = geo.centersFromTop[prizeIndex];
    var fullTurns = 5 + Math.floor(Math.random() * 3);
    return fullTurns * 360 + (360 - segmentCenter);
  }

  var SLOTS_STRIP_LOOPS = 5;

  function createSlotCell(prize) {
    var cell = document.createElement('div');
    cell.className = 'spin-wheel-slots__cell';
    var symbol = document.createElement('div');
    symbol.className = 'spin-wheel-slots__symbol';
    symbol.style.setProperty('--sw-slot-bg', normalizeColor(prize && prize.color) || '#4663a8');
    var imgUrl = String((prize && prize.symbol_image) || '').trim();
    if (imgUrl) {
      var img = document.createElement('img');
      img.src = imgUrl;
      img.alt = '';
      img.loading = 'lazy';
      img.decoding = 'async';
      symbol.appendChild(img);
    } else {
      symbol.textContent = (prize && prize.label) || 'Premio';
    }
    cell.appendChild(symbol);
    return cell;
  }

  function paintSlots(slotsRoot, prizes) {
    if (!slotsRoot || !prizes || prizes.length < 2) return;
    var strips = slotsRoot.querySelectorAll('[data-spin-wheel-reel-strip]');
    for (var s = 0; s < strips.length; s++) {
      var strip = strips[s];
      strip.innerHTML = '';
      strip.style.transition = '';
      strip.style.animation = '';
      strip.style.transform = 'translateY(0)';
      for (var loop = 0; loop < SLOTS_STRIP_LOOPS; loop++) {
        for (var i = 0; i < prizes.length; i++) {
          strip.appendChild(createSlotCell(prizes[i]));
        }
      }
    }
  }

  /**
   * Premio real → 3 iguales. Try-again → 3 símbolos distintos (centro = premio elegido).
   */
  function pickSlotsFinalIndices(prizes, prizeIndex) {
    var prize = prizes[prizeIndex];
    if (!isTryAgainPrize(prize)) {
      return [prizeIndex, prizeIndex, prizeIndex];
    }

    var n = prizes.length;
    if (n < 2) return [prizeIndex, prizeIndex, prizeIndex];
    if (n === 2) {
      var other = prizeIndex === 0 ? 1 : 0;
      return [other, prizeIndex, other];
    }

    var pool = [];
    for (var i = 0; i < n; i++) {
      if (i !== prizeIndex) pool.push(i);
    }
    for (var a = pool.length - 1; a > 0; a--) {
      var b = Math.floor(Math.random() * (a + 1));
      var tmp = pool[a];
      pool[a] = pool[b];
      pool[b] = tmp;
    }
    return [pool[0], prizeIndex, pool[1]];
  }

  function measureSlotCellHeight(strip) {
    var cell = strip && strip.querySelector('.spin-wheel-slots__cell');
    if (cell && cell.offsetHeight > 0) return cell.offsetHeight;
    var win = strip && strip.parentElement;
    if (win && win.clientHeight > 0) return win.clientHeight;
    return 88;
  }

  function animateReelStrip(strip, finalIndex, prizeCount, durationMs) {
    return new Promise(function (resolve) {
      if (!strip) {
        resolve();
        return;
      }

      var cellH = measureSlotCellHeight(strip);
      var targetLoop = Math.max(1, SLOTS_STRIP_LOOPS - 2);
      var from = 0;
      var to = -(targetLoop * prizeCount + finalIndex) * cellH;
      var done = false;
      var finish = function () {
        if (done) return;
        done = true;
        strip.style.transition = '';
        strip.style.transform = 'translateY(' + to + 'px)';
        resolve();
      };

      if (typeof strip.animate === 'function') {
        try {
          var anim = strip.animate(
            [
              { transform: 'translateY(' + from + 'px)' },
              { transform: 'translateY(' + to + 'px)' }
            ],
            {
              duration: durationMs,
              easing: 'cubic-bezier(0.12, 0.75, 0.08, 1)',
              fill: 'forwards'
            }
          );
          anim.onfinish = function () {
            try {
              anim.commitStyles();
              anim.cancel();
            } catch (e) {
              /* older Safari */
            }
            finish();
          };
          setTimeout(finish, durationMs + 250);
          return;
        } catch (err) {
          /* fallback CSS below */
        }
      }

      strip.style.transition = 'none';
      strip.style.transform = 'translateY(' + from + 'px)';
      void strip.offsetWidth;
      strip.style.transition =
        'transform ' + durationMs + 'ms cubic-bezier(0.12, 0.75, 0.08, 1)';
      strip.style.transform = 'translateY(' + to + 'px)';
      setTimeout(finish, durationMs + 100);
    });
  }

  function SpinWheel(root) {
    this.root = root;
    this.overlay = root.querySelector('[data-spin-wheel-overlay]');
    this.modal = root.querySelector('.spin-wheel-modal');
    this.disc = root.querySelector('[data-spin-wheel-disc]');
    this.labelsEl = root.querySelector('[data-spin-wheel-labels]');
    this.slotsEl = root.querySelector('[data-spin-wheel-slots]');
    this.reelStrips = this.slotsEl
      ? Array.prototype.slice.call(this.slotsEl.querySelectorAll('[data-spin-wheel-reel-strip]'))
      : [];
    this.gameType =
      (root.dataset.gameType || 'wheel').toLowerCase() === 'slots' ? 'slots' : 'wheel';
    this.form = root.querySelector('.spin-wheel-form');
    this.spinBtn = root.querySelector('[data-spin-wheel-spin]');
    this.formError = root.querySelector('[data-spin-wheel-form-error]');
    this.resultEl = root.querySelector('[data-spin-wheel-result]');
    this.resultWinEl = root.querySelector('[data-spin-wheel-result-win]');
    this.resultGiftEl = root.querySelector('[data-spin-wheel-result-gift]');
    this.resultLoseEl = root.querySelector('[data-spin-wheel-result-lose]');
    this.codeWrapEl = root.querySelector('[data-spin-wheel-code-wrap]');
    this.codeEl = root.querySelector('[data-spin-wheel-code]');
    this.prizeLabelEl = root.querySelector('[data-spin-wheel-prize-label]');
    this.redemptionEl = root.querySelector('[data-spin-wheel-redemption]');
    this.bannerEl = root.querySelector('[data-spin-wheel-banner]');
    this.winSubtitleEl = root.querySelector('[data-spin-wheel-win-subtitle]');
    this.disclaimerEl = root.querySelector('[data-spin-wheel-disclaimer]');
    this.giftPrizeLabelEl = root.querySelector('[data-spin-wheel-gift-prize-label]');
    this.giftStatusEl = root.querySelector('[data-spin-wheel-gift-status]');
    this.countdownEl = root.querySelector('[data-spin-wheel-countdown]');
    this.countdownLabelEl = root.querySelector('[data-spin-wheel-countdown-label]');
    this.countdownTimeEl = root.querySelector('[data-spin-wheel-countdown-time]');
    this._countdownTimer = null;
    this.viewCartBtn = root.querySelector('[data-spin-wheel-view-cart]');
    this.losePrizeLabelEl = root.querySelector('[data-spin-wheel-lose-prize-label]');
    this.copyBtn = root.querySelector('[data-spin-wheel-copy]');
    this.tryAgainBtn = root.querySelector('[data-spin-wheel-try-again]');
    this.formWrap = root.querySelector('[data-spin-wheel-form-wrap]');
    this.floatingBtn = root.querySelector('[data-spin-wheel-open]');
    this.prizes = sortPrizes(parseJson(root.querySelector('[data-spin-wheel-prizes]'), []));
    this.ledger = parseJson(root.querySelector('[data-spin-wheel-ledger]'), null);
    if (!this.ledger || !this.ledger.enabled) {
      this.ledger =
        root.dataset.ledgerEnabled === 'true'
          ? {
              enabled: true,
              campaign_key: root.dataset.ledgerCampaignKey || '',
              hydrogen_base_url: root.dataset.ledgerHydrogenBase || '',
              sheet_tab: root.dataset.ledgerSheetTab || ''
            }
          : null;
    }
    try {
      if (this.getHydrogenBase() && !this.hasLedgerMode()) {
        console.warn(
          '[spin-wheel] Hydrogen OK pero ledger OFF. field=',
          root.dataset.ledgerField || '(none)',
          'resolved=',
          root.dataset.ledgerResolved,
          'handle=',
          root.dataset.ledgerHandle || '(none)',
          'sheet_tab=',
          root.dataset.ledgerSheetTab || '(empty)',
          '→ sin /api/promo/spin ni /finalize'
        );
      }
    } catch (ledgerDiagErr) {
      /* ignore */
    }
    this.isOpen = false;
    this.hasSpunThisSession = false;
    this.autoTimer = null;
    this.submitIframe = null;
    this._scrollLocked = false;
    this._currentRotation = 0;
    this._retrySpinning = false;
    this._giftFulfillment = null;
    this._ledgerFinalized = false;

    this.bindEvents();
    this.root._kronoSpinWheel = this;

    if (this.prizes.length < 2) {
      this.setFloatingVisible(false);
      this.restoreCountdown();
      return;
    }

    this.prepareForm();
    /* sheet_tab=stores → copy *_stores desde el boot. */
    this.applyChannelCopy();
    this.init();

    /*
     * En la landing incrustada ([data-sr-wheel-slot]) moveWheel reparenta el root
     * en DOMContentLoaded. Si checkPostSubmitState corre antes (script defer) y
     * arranca animateSpin, el reparent cancela la transición CSS → no se ve el giro.
     */
    var self = this;
    var finishBoot = function () {
      self.checkPostSubmitState();
      self.restoreCountdown();
    };

    if (document.querySelector('[data-sr-wheel-slot]')) {
      var runAfterEmbed = function () {
        requestAnimationFrame(function () {
          requestAnimationFrame(finishBoot);
        });
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', runAfterEmbed);
      } else {
        runAfterEmbed();
      }
    } else {
      finishBoot();
    }
  }

  SpinWheel.prototype.prepareForm = function () {
    if (!this.form) return;

    var action = this.form.getAttribute('action') || '/contact';
    if (action.indexOf('#') !== -1) {
      this.form.setAttribute('action', action.split('#')[0]);
    }

    /*
     * stores_h2_subscribe: el form customer solo aporta campos/UI.
     * No debe POST a /contact (evita ?customer_posted=true).
     */
    if (this.hasH2SubscribeFlag()) {
      var selfPrep = this;
      this.form.setAttribute('data-h2-subscribe-only', 'true');
      this.form.setAttribute('action', '#');
      if (this.spinBtn && this.spinBtn.tagName === 'BUTTON') {
        this.spinBtn.setAttribute('type', 'button');
        if (!this.spinBtn._h2ClickBound) {
          this.spinBtn._h2ClickBound = true;
          this.spinBtn.addEventListener('click', function (e) {
            e.preventDefault();
            selfPrep.handleFormSubmit(e);
          });
        }
      }
    }
  };

  SpinWheel.prototype.lockPageScroll = function () {
    if (this._scrollLocked) return;

    this._savedScrollX = window.scrollX || window.pageXOffset || 0;
    this._savedScrollY = window.scrollY || window.pageYOffset || 0;
    this._scrollLocked = true;

    document.body.classList.add('spin-wheel-scroll-lock');
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + this._savedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  };

  SpinWheel.prototype.unlockPageScroll = function () {
    if (!this._scrollLocked) return;

    var x = this._savedScrollX || 0;
    var y = this._savedScrollY || 0;

    this._scrollLocked = false;
    document.body.classList.remove('spin-wheel-scroll-lock');
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';

    window.scrollTo(x, y);
  };

  SpinWheel.prototype.getSpinLabel = function () {
    return this.root.dataset.spinLabel || 'Girar la ruleta';
  };

  SpinWheel.prototype.getPendingSubmitKey = function () {
    return getStorageKey(this.root.dataset.campaignId, 'pending-submit');
  };

  SpinWheel.prototype.markPendingSubmit = function () {
    writeStorage(this.getPendingSubmitKey(), String(Date.now()));
  };

  SpinWheel.prototype.clearPendingSubmit = function () {
    clearStorage(this.getPendingSubmitKey());
  };

  SpinWheel.prototype.hasPendingSubmit = function () {
    var val = readStorage(this.getPendingSubmitKey());
    if (!val) return false;
    var ts = parseInt(val, 10);
    if (!ts || Date.now() - ts > 120000) {
      clearStorage(this.getPendingSubmitKey());
      return false;
    }
    return true;
  };

  SpinWheel.prototype.isFormReturnHash = function () {
    if (!this.form || !this.form.id) return false;
    var hash = (window.location.hash || '').replace(/^#/, '');
    return hash === this.form.id;
  };

  SpinWheel.prototype.cleanReturnHash = function () {
    if (!this.isFormReturnHash()) return;
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  };

  SpinWheel.prototype.setFloatingVisible = function (visible) {
    if (!this.floatingBtn) return;
    this.floatingBtn.hidden = !visible;
    this.floatingBtn.style.display = visible ? '' : 'none';
  };

  SpinWheel.prototype.canShowPopup = function (manualOpen) {
    if (!matchesScope(this.root)) return false;
    if (!manualOpen && isDismissed(this.root)) return false;
    if (!canSpinAgain(this.root)) return false;
    return true;
  };

  SpinWheel.prototype.shouldShowFloatingButton = function () {
    if (!matchesScope(this.root)) return false;
    if (!canSpinAgain(this.root)) return false;
    return true;
  };

  SpinWheel.prototype.init = function () {
    if (!matchesScope(this.root)) {
      this.setFloatingVisible(false);
      return;
    }

    if (this.gameType === 'slots' && this.slotsEl) {
      paintSlots(this.slotsEl, this.prizes);
    } else if (this.disc) {
      paintWheel(this.disc, this.labelsEl, this.prizes);
    }

    var triggerMode = (this.root.dataset.triggerMode || 'manual').toLowerCase();
    var showFloating = this.root.dataset.showFloating === 'true';
    var afterInvoiceOnly =
      triggerMode === 'after_invoice' ||
      triggerMode === 'after_form' ||
      triggerMode === 'form';

    /* after_invoice: solo se abre tras el form de facturas (KronoSpinWheel.openAfterInvoice). */
    if (afterInvoiceOnly || pageHasInvoiceForm()) {
      this.setFloatingVisible(false);
      this.updateSpinButtonState();
      return;
    }

    if (showFloating && this.shouldShowFloatingButton()) {
      this.setFloatingVisible(true);
    } else {
      this.setFloatingVisible(false);
    }

    this.updateSpinButtonState();

    if (!isDismissed(this.root) && (triggerMode === 'auto' || triggerMode === 'both')) {
      this.setupAutoTrigger();
    }
  };

  SpinWheel.prototype.bindEvents = function () {
    var self = this;

    this.root.querySelectorAll('[data-spin-wheel-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.open(true);
      });
    });

    this.root.querySelectorAll('[data-spin-wheel-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.close(true);
      });
    });

    var dismissLink = this.root.querySelector('[data-spin-wheel-dismiss]');
    if (dismissLink) {
      dismissLink.addEventListener('click', function (e) {
        var href = (self.root.dataset.dismissUrl || '').trim();
        setDismissed(self.root);
        var isCloseOnly = !href || href === '#' || href === '#!';
        if (isCloseOnly) {
          e.preventDefault();
        }
        self.close(false);
      });
    }

    if (this.overlay) {
      this.overlay.addEventListener('click', function (e) {
        if (e.target === self.overlay) self.close(true);
      });
    }

    if (this.form) {
      this.form.addEventListener('submit', function (e) {
        e.preventDefault();
        self.handleFormSubmit(e);
      });

      this.form.querySelectorAll('[data-spin-wheel-field], [data-spin-wheel-privacy]').forEach(function (field) {
        field.addEventListener('input', function () {
          self.updateSpinButtonState();
        });
        field.addEventListener('change', function () {
          self.updateSpinButtonState();
        });
      });
    }

    if (this.copyBtn) {
      this.copyBtn.addEventListener('click', function () {
        self.copyCode();
      });
    }

    if (this.tryAgainBtn) {
      this.tryAgainBtn.addEventListener('click', function () {
        self.handleTryAgain();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.isOpen) self.close(true);
    });
  };

  SpinWheel.prototype.setupAutoTrigger = function () {
    var mode = (this.root.dataset.triggerMode || 'manual').toLowerCase();
    if (mode !== 'auto' && mode !== 'both') return;
    if (!this.canShowPopup()) return;

    var delaySeconds = parseInt(this.root.dataset.autoDelay, 10);
    if (isNaN(delaySeconds)) delaySeconds = 5;
    var delay = delaySeconds * 1000;
    var self = this;
    this.autoTimer = setTimeout(function () {
      if (!self.isOpen) self.open();
    }, delay);
  };

  SpinWheel.prototype.updateSpinButtonState = function () {
    if (!this.spinBtn || !this.form) return;
    this.spinBtn.disabled = !this.isFormValid();
  };

  SpinWheel.prototype.isFormValid = function () {
    if (!this.form) return true;

    var requireEmail = this.root.dataset.requireEmail === 'true';
    if (requireEmail) {
      var emailInput = this.form.querySelector('[data-spin-wheel-email]') ||
        this.form.querySelector('input[type="email"][name="contact[email]"]') ||
        this.form.querySelector('input[type="email"]');
      if (!emailInput || !emailInput.value.trim()) return false;
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput.value.trim())) return false;
    }

    var requiredFields = this.form.querySelectorAll('[data-spin-wheel-required]');
    for (var i = 0; i < requiredFields.length; i++) {
      var field = requiredFields[i];
      if (field.type === 'checkbox' && !field.checked) return false;
      if (field.type !== 'checkbox' && !field.value.trim()) return false;
    }

    var privacyRequired = this.root.dataset.privacyRequired === 'true';
    if (privacyRequired) {
      var privacy = this.form.querySelector('[data-spin-wheel-privacy]');
      if (privacy && !privacy.checked) return false;
    }

    return true;
  };

  SpinWheel.prototype.open = function (manualOpen) {
    if (this.isOpen) return;
    if (!this.overlay) return;
    if (!this.canShowPopup(manualOpen)) return;
    this.openAfterSubmit();
  };

  SpinWheel.prototype.openAfterSubmit = function () {
    if (this.isOpen || !this.overlay) return;

    if (this.autoTimer) {
      clearTimeout(this.autoTimer);
      this.autoTimer = null;
    }

    this.applyChannelCopy();

    this.isOpen = true;
    this.overlay.removeAttribute('hidden');
    this.overlay.setAttribute('aria-hidden', 'false');

    var overlay = this.overlay;
    requestAnimationFrame(function () {
      overlay.classList.add('is-open');
    });

    this.lockPageScroll();

    if (!this._wheelPainted && this.prizes.length >= 2) {
      if (this.gameType === 'slots' && this.slotsEl) {
        paintSlots(this.slotsEl, this.prizes);
      } else if (this.disc) {
        paintWheel(this.disc, this.labelsEl, this.prizes);
      }
      this._wheelPainted = true;
    }
  };

  SpinWheel.prototype.close = function (applyDismiss) {
    if (!this.isOpen) return;

    /*
      Ruletas con form: al cerrar un premio ganado (código u obsequio),
      recargar para que el siguiente registro en el mismo PC no vea
      el resultado pegado. No recargar en "sigue intentando" — ahí
      aún puede reintentar con el mismo registro.
    */
    var reloadAfterClose =
      !!this.form &&
      this.modal &&
      this.modal.classList.contains('is-result') &&
      !this.modal.classList.contains('is-try-again');

    this.isOpen = false;
    this.overlay.classList.remove('is-open');
    this.overlay.setAttribute('aria-hidden', 'true');
    this.unlockPageScroll();

    var self = this;
    setTimeout(function () {
      self.overlay.setAttribute('hidden', '');
    }, 350);

    if (applyDismiss && !this.hasSpunThisSession) {
      setDismissed(this.root);
    }

    if (reloadAfterClose) {
      if (
        typeof this.isStoresChannel === 'function' &&
        (this.isStoresChannel() || pageHasInvoiceForm())
      ) {
        resetClientSpinBudget(this.root);
      }
      window.location.reload();
    }
  };

  SpinWheel.prototype.showFormError = function (msg) {
    if (!this.formError) return;
    this.formError.textContent = msg;
    this.formError.hidden = false;
  };

  SpinWheel.prototype.hideFormError = function () {
    if (this.formError) this.formError.hidden = true;
  };

  SpinWheel.prototype.ensureCustomerEmailField = function () {
    if (!this.form) return '';

    var emailInput =
      this.form.querySelector('[data-spin-wheel-email]') ||
      this.form.querySelector('input[type="email"][name="contact[email]"]') ||
      this.form.querySelector('input[type="email"]');

    var email = emailInput ? String(emailInput.value || '').trim() : '';
    if (!email) return '';

    var named = this.form.querySelector('input[name="contact[email]"]');
    if (!named) {
      named = document.createElement('input');
      named.type = 'hidden';
      named.name = 'contact[email]';
      this.form.appendChild(named);
    }

    if (named !== emailInput) {
      named.value = email;
    }

    return email;
  };

  SpinWheel.prototype.submitNativeFullPage = function () {
    if (!this.form) return;
    if (this.wantsH2EnsureSubscriber()) {
      try {
        console.warn(
          '[spin-wheel] bloqueado submit nativo /contact (stores_h2_subscribe / H2)'
        );
      } catch (e) {
        /* ignore */
      }
      return;
    }
    this.markPendingSubmit();
    this.form.removeAttribute('target');
    this.form.target = '';
    // Envío nativo = mismo path que el newsletter del footer → crea el customer.
    this.form.submit();
  };

  SpinWheel.prototype.ensureSubmitIframe = function () {
    if (this.submitIframe && this.submitIframe.parentNode) {
      return this.submitIframe;
    }

    var iframe = document.createElement('iframe');
    iframe.name = 'spin-wheel-submit-frame';
    iframe.title = 'Spin wheel submit';
    iframe.setAttribute('aria-hidden', 'true');
    iframe.tabIndex = -1;
    iframe.style.cssText = 'position:absolute;left:-9999px;width:1px;height:1px;border:0;';
    document.body.appendChild(iframe);
    this.submitIframe = iframe;
    return iframe;
  };

  SpinWheel.prototype.submitViaIframe = function () {
    if (this.wantsH2EnsureSubscriber()) {
      return Promise.reject(
        new Error(
          'Suscripci\u00F3n Shopify deshabilitada (stores_h2_subscribe). Usa Hydrogen.'
        )
      );
    }

    var form = this.form;
    var formId = form.id;
    var iframe = this.ensureSubmitIframe();

    return new Promise(function (resolve, reject) {
      var settled = false;
      var pollCount = 0;
      var maxPolls = 50;
      var pollTimer = null;
      var lastDoc = null;
      var lastHtml = '';
      var sawCloudflare = false;

      function cleanup() {
        if (pollTimer) clearInterval(pollTimer);
        form.removeAttribute('target');
      }

      function finish(success, message) {
        if (settled) return;
        settled = true;
        cleanup();
        if (success) resolve(true);
        else reject(new Error(message || 'No se pudo registrar el email. Intenta de nuevo.'));
      }

      function tryParse() {
        pollCount++;

        var doc = null;
        try {
          doc = iframe.contentDocument || (iframe.contentWindow && iframe.contentWindow.document);
        } catch (err) {
          if (pollCount > maxPolls) {
            finish(false, 'No se pudo validar el registro. Recarga e intenta de nuevo.');
          }
          return;
        }

        if (!doc || !doc.body) {
          if (pollCount > maxPolls) {
            finish(false);
          }
          return;
        }

        var html = doc.documentElement ? doc.documentElement.innerHTML : '';
        if (!html || html.length < 200) {
          if (pollCount > maxPolls) {
            finish(false);
          }
          return;
        }

        lastDoc = doc;
        lastHtml = html;

        if (isCloudflareChallenge(html)) {
          sawCloudflare = true;
          if (pollCount > maxPolls) {
            finish(false, 'No se pudo validar el registro. Recarga e intenta de nuevo.');
          }
          return;
        }

        var parsed = inspectCustomerForm(doc, formId);
        if (parsed && parsed.ok) {
          finish(true);
          return;
        }

        if (parsed && parsed.definiteError) {
          finish(false, parsed.message);
          return;
        }

        if (looksLikeSuccessfulStorefrontResponse(doc, formId, html)) {
          finish(true);
          return;
        }

        if (pollCount > maxPolls) {
          if (lastDoc && looksLikeSuccessfulStorefrontResponse(lastDoc, formId, lastHtml)) {
            finish(true);
          } else {
            finish(
              false,
              sawCloudflare
                ? 'No se pudo validar el registro. Recarga e intenta de nuevo.'
                : 'No se pudo confirmar el registro. Intenta de nuevo.'
            );
          }
        }
      }

      pollTimer = setInterval(tryParse, 200);
      iframe.addEventListener('load', tryParse);

      form.setAttribute('target', iframe.name);
      form.target = iframe.name;
      form.submit();
    });
  };

  SpinWheel.prototype.checkPostSubmitState = function () {
    if (!this.form) return;

    var successMarker = this.form.querySelector('[data-spin-wheel-subscribe-success]');
    var errorMarker = this.form.querySelector('[data-spin-wheel-subscribe-error]');

    if (successMarker) {
      this.clearPendingSubmit();
      this.cleanReturnHash();
      this.openAfterSubmit();
      this.runPostSubmitSuccess();
      return;
    }

    if (errorMarker) {
      var errorResult = parseKnownCustomerError(stripHtml(errorMarker.innerHTML));
      this.clearPendingSubmit();
      this.cleanReturnHash();

      if (errorResult.ok) {
        this.openAfterSubmit();
        this.runPostSubmitSuccess();
        return;
      }

      this.openAfterSubmit();
      this.showFormError(errorResult.message);
      return;
    }

    if (this.hasPendingSubmit()) {
      this.clearPendingSubmit();
      this.cleanReturnHash();
      this.openAfterSubmit();
      this.runPostSubmitSuccess();
      return;
    }

    if (this.isFormReturnHash()) {
      this.cleanReturnHash();
    }
  };

  SpinWheel.prototype.runPostSubmitSuccess = function () {
    var self = this;

    if (!canSpinAgain(this.root)) {
      this.showFormError(MSG_MAX_SPINS);
      return;
    }

    /* Ledger sin sesión: solo flag H2 directo (pesos cliente). Factura → token obligatorio. */
    if (
      this.hasLedgerMode() &&
      !this.getSessionToken() &&
      !this.hasH2SubscribeFlag()
    ) {
      this.showFormError(MSG_LEDGER_SESSION_MISSING);
      return;
    }

    this.hideFormError();
    this.hasSpunThisSession = true;

    if (this.formWrap) this.formWrap.hidden = false;
    if (this.resultEl) this.resultEl.hidden = true;
    if (this.spinBtn) {
      this.spinBtn.disabled = true;
      this.spinBtn.textContent = MSG_SPINNING;
    }
    this.modal.classList.add('is-spinning');

    this.animateGame()
      .then(function (prize) {
        incrementSpinCount(self.root);
        self.showResult(prize);
      })
      .catch(function (err) {
        if (self.spinBtn) {
          self.spinBtn.disabled = !self.isFormValid();
          self.spinBtn.textContent = self.getSpinLabel();
        }
        self.modal.classList.remove('is-spinning');
        self.showFormError((err && err.message) || MSG_LEDGER_SPIN_ERROR);
      });
  };

  SpinWheel.prototype.handleFormSubmit = function (event) {
    event.preventDefault();

    if (!this.isFormValid()) {
      this.showFormError('Completa todos los campos obligatorios.');
      return;
    }

    if (!canSpinAgain(this.root)) {
      this.showFormError(MSG_MAX_SPINS);
      return;
    }

    if (!this.ensureCustomerEmailField()) {
      this.showFormError('Ingresa un email v\u00E1lido.');
      return;
    }

    this.hideFormError();
    this.markPendingSubmit();

    if (this.spinBtn) {
      this.spinBtn.textContent = MSG_REGISTERING;
    }

    var self = this;
    var email = this.getFormEmail();

    function resetSpinBtn() {
      if (self.spinBtn) {
        self.spinBtn.disabled = !self.isFormValid();
        self.spinBtn.textContent = self.getSpinLabel();
      }
    }

    function submitShopifyForm() {
      if (self.wantsH2EnsureSubscriber()) {
        self.clearPendingSubmit();
        self.showFormError(
          'Suscripci\u00F3n por Hydrogen obligatoria. No se usa el form Shopify.'
        );
        resetSpinBtn();
        return;
      }
      self
        .submitViaIframe()
        .then(function () {
          self.clearPendingSubmit();
          self.runPostSubmitSuccess();
        })
        .catch(function (err) {
          var msg = (err && err.message) || '';
          var needsNative =
            !msg ||
            msg.indexOf('No se pudo confirmar') !== -1 ||
            msg.indexOf('No se pudo validar') !== -1 ||
            msg.indexOf('No se pudo registrar') !== -1;

          if (!needsNative || self.wantsH2EnsureSubscriber()) {
            self.clearPendingSubmit();
            self.showFormError(msg || MSG_TAG_CAMPAIGN_ERROR);
            resetSpinBtn();
            return;
          }

          // Sin fetch (CF lo bloquea). Fallback nativo = crea el suscriptor.
          if (self.spinBtn) {
            self.spinBtn.textContent = MSG_REGISTERING;
          }
          self.submitNativeFullPage();
        });
    }

    /* H2 primero: ya suscrito → solo tags (sin form / challenge). */
    this.tryHydrogenSubscribePath(email)
      .then(function (result) {
        if (result && result.usedHydrogen) {
          self.clearPendingSubmit();
          self.runPostSubmitSuccess();
          return;
        }
        /*
         * stores_h2_subscribe / tiendas+token: NUNCA form Shopify
         * (evita ?customer_posted=true y Cloudflare).
         */
        if (self.wantsH2EnsureSubscriber()) {
          self.clearPendingSubmit();
          self.showFormError(
            (result && result.message) ||
              'No se pudo suscribir por Hydrogen. Revisa la URL H2 o intenta de nuevo.'
          );
          resetSpinBtn();
          return;
        }
        submitShopifyForm();
      })
      .catch(function (err) {
        /* Ya suscrito pero ensure-tags falló / ensure-subscriber falló: no girar. */
        self.clearPendingSubmit();
        self.showFormError((err && err.message) || MSG_TAG_CAMPAIGN_ERROR);
        resetSpinBtn();
      });
  };

  SpinWheel.prototype.hasLedgerMode = function () {
    return !!(
      this.ledger &&
      this.ledger.enabled &&
      this.getHydrogenBase() &&
      this.getLedgerSheetTab()
    );
  };

  /**
   * URL Hydrogen (todas las ruletas):
   * campaña data-hydrogen-base-url → ledger → (Liquid ya resolvió Theme settings).
   */
  SpinWheel.prototype.getHydrogenBase = function () {
    return String(
      this.root.dataset.hydrogenBaseUrl ||
        (this.ledger && this.ledger.hydrogen_base_url) ||
        this.root.dataset.ledgerHydrogenBase ||
        ''
    ).trim();
  };

  var SAFE_EMAIL_RE =
    /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)+$/i;
  var SAFE_TAG_RE = /^[a-zA-Z0-9][a-zA-Z0-9_\-. ]{0,62}$/;

  function sanitizeEmailClient(raw) {
    var email = String(raw || '')
      .trim()
      .toLowerCase()
      .slice(0, 254);
    if (!email || !SAFE_EMAIL_RE.test(email)) return '';
    return email;
  }

  function sanitizeTagClient(raw) {
    var tag = String(raw || '')
      .trim()
      .replace(/\s+/g, ' ')
      .slice(0, 64);
    if (!tag || !SAFE_TAG_RE.test(tag)) return '';
    return tag;
  }

  SpinWheel.prototype.getCampaignTags = function () {
    var seen = {};
    var out = [];
    String(this.root.dataset.baseTags || '')
      .split(',')
      .forEach(function (t) {
        if (out.length >= 20) return;
        var tag = sanitizeTagClient(t);
        if (!tag) return;
        var key = tag.toLowerCase();
        if (seen[key]) return;
        seen[key] = true;
        out.push(tag);
      });
    return out;
  };

  SpinWheel.prototype.getFormEmail = function () {
    if (!this.form) return '';
    var emailInput =
      this.form.querySelector('[data-spin-wheel-email]') ||
      this.form.querySelector('input[type="email"][name="contact[email]"]') ||
      this.form.querySelector('input[type="email"]');
    return sanitizeEmailClient(emailInput ? emailInput.value : '');
  };

  /**
   * Consulta si el email ya está suscrito (Admin vía H2).
   * Si H2 falla → null (el caller hace fallback al form Shopify).
   */
  SpinWheel.prototype.fetchSubscriptionStatus = function (email) {
    var base = this.getHydrogenBase();
    if (!base || !email) return Promise.resolve(null);

    return fetch(promoApiUrl(base, 'api/customer/subscription-status'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'omit',
      body: JSON.stringify({ email: email })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || !data || data.error) return null;
          return data;
        });
      })
      .catch(function () {
        return null;
      });
  };

  /**
   * tagsAdd de campaña para cliente ya suscrito (sin form Shopify).
   */
  SpinWheel.prototype.ensureCampaignTags = function (email) {
    var base = this.getHydrogenBase();
    var tags = this.getCampaignTags();
    if (!base || !email || !tags.length) {
      return Promise.reject(new Error(MSG_TAG_CAMPAIGN_ERROR));
    }

    return fetch(promoApiUrl(base, 'api/customer/ensure-tags'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'omit',
      body: JSON.stringify({ email: email, tags: tags })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || !data || data.error) {
          throw new Error((data && data.message) || MSG_TAG_CAMPAIGN_ERROR);
        }
        return data;
      });
    });
  };

  /**
   * ensure-subscriber vía H2 (sin form Shopify / CF challenge).
   * - Tiendas + session_token → { email, tags, session_token, channel: "stores" }
   * - stores_h2_subscribe (directo) → { email, tags }
   */
  SpinWheel.prototype.ensureSubscriberViaHydrogen = function (email) {
    var base = this.getHydrogenBase();
    var tags = this.getCampaignTags();
    var token = this.getSessionToken();
    var storesSession =
      this.getLedgerSheetTab() === 'stores' && !!token;
    if (!base || !email || !tags.length) {
      return Promise.reject(new Error(MSG_TAG_CAMPAIGN_ERROR));
    }
    if (!storesSession && !this.hasH2SubscribeFlag()) {
      return Promise.reject(new Error(MSG_TAG_CAMPAIGN_ERROR));
    }

    var body = { email: email, tags: tags };
    if (storesSession) {
      body.session_token = token;
      body.channel = 'stores';
      body.sheet_tab = 'stores';
    }

    return fetch(promoApiUrl(base, 'api/customer/ensure-subscriber'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'omit',
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || !data || data.error) {
          throw new Error((data && data.message) || MSG_TAG_CAMPAIGN_ERROR);
        }
        return data;
      });
    });
  };

  /** @deprecated alias — usar ensureSubscriberViaHydrogen */
  SpinWheel.prototype.ensureStoresSubscriber = function (email) {
    return this.ensureSubscriberViaHydrogen(email);
  };

  /**
   * Si ya suscrito → ensure-tags y listo (sin form).
   * Flag stores_h2_subscribe o tiendas+token → ensure-subscriber.
   * Online sin flag → false para form nativo Shopify.
   */
  SpinWheel.prototype.tryHydrogenSubscribePath = function (email) {
    var self = this;
    if (!email) {
      return Promise.resolve({ usedHydrogen: false });
    }

    if (!this.getHydrogenBase()) {
      if (this.wantsH2EnsureSubscriber()) {
        return Promise.reject(
          new Error(
            'Falta hydrogen_base_url en la campa\u00F1a / Theme settings (stores_h2_subscribe).'
          )
        );
      }
      return Promise.resolve({ usedHydrogen: false });
    }

    return this.fetchSubscriptionStatus(email).then(function (status) {
      if (status && status.subscribed === true) {
        return self.ensureCampaignTags(email).then(function () {
          return { usedHydrogen: true };
        });
      }

      if (self.wantsH2EnsureSubscriber()) {
        return self.ensureSubscriberViaHydrogen(email).then(function () {
          return { usedHydrogen: true };
        });
      }

      return { usedHydrogen: false };
    });
  };

  SpinWheel.prototype.getLedgerCampaignKey = function () {
    return String(
      (this.ledger && this.ledger.campaign_key) ||
        this.root.dataset.ledgerCampaignKey ||
        this.root.dataset.campaignHandle ||
        this.root.dataset.campaignId ||
        ''
    ).trim();
  };

  /**
   * Pestaña Sheet: online | stores.
   * Prioridad: override del form de facturas (channel) → promo_ledger.sheet_tab.
   * Sin override, un registro en "stores" rompía /spin al buscar la sesión en "online".
   */
  SpinWheel.prototype.getLedgerSheetTab = function () {
    return String(
      this._ledgerSheetTabOverride ||
        (this.ledger && this.ledger.sheet_tab) ||
        this.root.dataset.ledgerSheetTab ||
        ''
    )
      .trim()
      .toLowerCase();
  };

  /** channel del form (online|stores) → pestaña Sheet para esta sesión. */
  SpinWheel.prototype.setLedgerSheetTabOverride = function (channelOrTab) {
    var tab = String(channelOrTab || '')
      .trim()
      .toLowerCase();
    if (tab === 'online' || tab === 'stores') {
      this._ledgerSheetTabOverride = tab;
      this.applyChannelCopy();
      return tab;
    }
    return '';
  };

  /**
   * Copia online vs stores (spin_wheel_content.*_stores).
   * Stores: banner / win subtitle / disclaimer de tienda; sin copy de checkout.
   */
  SpinWheel.prototype.applyChannelCopy = function () {
    var stores = this.isStoresChannel();
    var ds = this.root.dataset;

    function setText(el, text, hideIfEmpty) {
      if (!el) return;
      var t = String(text || '').trim();
      if (!t && hideIfEmpty) {
        el.hidden = true;
        el.textContent = '';
        return;
      }
      el.hidden = false;
      el.textContent = t;
    }

    if (this.bannerEl) {
      var bannerOnline = String(ds.bannerText || '').trim();
      var bannerStores = String(ds.bannerTextStores || '').trim();
      if (stores) {
        if (bannerStores) {
          this.bannerEl.hidden = false;
          this.bannerEl.textContent = bannerStores;
        } else {
          /* No reutilizar banner online (“EXCLUSIVO ONLINE”). */
          this.bannerEl.hidden = true;
          this.bannerEl.textContent = '';
        }
      } else if (bannerOnline) {
        this.bannerEl.hidden = false;
        this.bannerEl.textContent = bannerOnline;
      } else {
        this.bannerEl.hidden = true;
      }
    }

    if (this.winSubtitleEl) {
      if (stores) {
        setText(
          this.winSubtitleEl,
          ds.winSubtitleStores ||
            (this.getSessionToken()
              ? 'Tu premio quedó registrado con tu factura. Preséntalo en tienda para reclamarlo.'
              : 'Preséntalo en tienda para reclamarlo.'),
          false
        );
      } else {
        setText(this.winSubtitleEl, ds.winSubtitle || '', true);
      }
    }

    if (this.disclaimerEl) {
      if (stores) {
        var discStores = String(ds.disclaimerStores || '').trim();
        if (discStores) {
          setText(this.disclaimerEl, discStores, false);
        } else {
          /* Sin disclaimer_stores: ocultar el de web/cupón. */
          this.disclaimerEl.hidden = true;
          this.disclaimerEl.textContent = '';
        }
      } else {
        setText(this.disclaimerEl, ds.disclaimer || '', true);
      }
    }
  };

  SpinWheel.prototype.getSessionToken = function () {
    return (
      readSessionToken(this.root.dataset.campaignId) ||
      readSessionToken(this.root.dataset.campaignHandle) ||
      readSessionToken(this.getLedgerCampaignKey()) ||
      readSessionToken('default')
    );
  };

  SpinWheel.prototype.getInvoiceOrderId = function () {
    return (
      sanitizeOrderId(this._invoiceOrderId) ||
      readOrderId(this.root.dataset.campaignId) ||
      readOrderId(this.root.dataset.campaignHandle) ||
      readOrderId(this.getLedgerCampaignKey()) ||
      readOrderId('default')
    );
  };

  SpinWheel.prototype.setInvoiceOrderId = function (orderId) {
    var id = sanitizeOrderId(orderId);
    if (!id) return;
    this._invoiceOrderId = id;
    writeOrderId(this.root.dataset.campaignId, id);
    writeOrderId(this.root.dataset.campaignHandle, id);
    writeOrderId(this.getLedgerCampaignKey(), id);
    writeOrderId('default', id);
  };

  /** Centavos del form tiendas (para /spin sin depender solo del Sheet). */
  SpinWheel.prototype.setInvoiceOrderTotal = function (centavos) {
    var n = Number(centavos);
    if (!Number.isFinite(n) || n < 1) return;
    this._invoiceOrderTotal = Math.round(n);
    writeOrderTotal(this.root.dataset.campaignId, this._invoiceOrderTotal);
    writeOrderTotal(this.root.dataset.campaignHandle, this._invoiceOrderTotal);
    writeOrderTotal(this.getLedgerCampaignKey(), this._invoiceOrderTotal);
    writeOrderTotal('default', this._invoiceOrderTotal);
  };

  SpinWheel.prototype.getInvoiceOrderTotal = function () {
    var n = Number(this._invoiceOrderTotal);
    if (Number.isFinite(n) && n > 0) return n;
    return (
      readOrderTotal(this.root.dataset.campaignId) ||
      readOrderTotal(this.root.dataset.campaignHandle) ||
      readOrderTotal(this.getLedgerCampaignKey()) ||
      readOrderTotal('default') ||
      0
    );
  };

  /**
   * Asigna cupón único vía H2.
   * type = discount_code del premio (plantilla, ej. "Ruleta - Bono 100K").
   * La respuesta es el código que se muestra / copia.
   */
  /** type para /api/customer-coupon = discount_code del metaobjeto (ej. "Ruleta - Bono 100K"). */
  SpinWheel.prototype.getCouponType = function (prize) {
    return (
      sanitizeCouponType(prize && prize.coupon_type) ||
      sanitizeCouponType(prize && prize.discount_code)
    );
  };

  SpinWheel.prototype.requestCustomerCoupon = function (prize) {
    var base = this.getHydrogenBase();
    var orderId = this.getInvoiceOrderId();
    var type = this.getCouponType(prize);
    if (!base || !orderId || !type) {
      return Promise.reject(new Error(MSG_COUPON_ASSIGN_ERROR));
    }

    return fetch(promoApiUrl(base, 'api/customer-coupon'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'omit',
      body: JSON.stringify({ orderId: orderId, type: type })
    }).then(function (res) {
      return res.json().then(function (data) {
        var code = extractCouponCodeFromResponse(data);
        if (!res.ok || !code) {
          throw new Error(
            (data && (data.error || data.message)) || MSG_COUPON_ASSIGN_ERROR
          );
        }
        return code;
      });
    });
  };

  /**
   * Canal tiendas (copy *_stores, sin cupón): solo sheet_tab=stores.
   * No usar stores_h2_subscribe aquí — ese flag es solo suscripción H2
   * (también en ruletas online tipo casino).
   */
  SpinWheel.prototype.isStoresChannel = function () {
    return this.getLedgerSheetTab() === 'stores';
  };

  /** campaign.stores_h2_subscribe → suscripción directa H2 { email, tags }. */
  SpinWheel.prototype.hasH2SubscribeFlag = function () {
    return this.root.dataset.storesH2Subscribe === 'true';
  };

  /** @deprecated alias de hasH2SubscribeFlag */
  SpinWheel.prototype.isStoresLandingSubscribe = function () {
    return this.hasH2SubscribeFlag();
  };

  /**
   * Usar ensure-subscriber:
   * - flag stores_h2_subscribe (modo directo), o
   * - tiendas + session_token (modo Sheet).
   */
  SpinWheel.prototype.wantsH2EnsureSubscriber = function () {
    if (this.hasH2SubscribeFlag()) return true;
    return this.isStoresChannel() && !!this.getSessionToken();
  };

  /** @deprecated alias de wantsH2EnsureSubscriber */
  SpinWheel.prototype.wantsStoresH2Subscribe = function () {
    return this.wantsH2EnsureSubscriber();
  };

  /**
   * Ledger con sesión (spin en Sheet) vs landing sin token (pesos cliente).
   */
  SpinWheel.prototype.shouldUseLedgerSpin = function () {
    return this.hasLedgerMode() && !!this.getSessionToken();
  };

  SpinWheel.prototype.shouldAssignUniqueCoupon = function (prize) {
    if (this.isStoresChannel()) return false;
    return !!(
      this.getHydrogenBase() &&
      this.getInvoiceOrderId() &&
      hasDiscountCode(prize) &&
      this.getCouponType(prize)
    );
  };

  SpinWheel.prototype.requestLedgerSpin = function () {
    var self = this;
    var base = this.getHydrogenBase();
    var token = this.getSessionToken();

    if (!base) {
      return Promise.reject(new Error(MSG_LEDGER_SPIN_ERROR));
    }
    if (!token) {
      return Promise.reject(new Error(MSG_LEDGER_SESSION_MISSING));
    }

    var sheetTab = this.getLedgerSheetTab();
    /* Solo online: invoice para order_total vía Shopify. */
    var orderId = sheetTab === 'stores' ? '' : this.getInvoiceOrderId();
    /* Stores: centavos del form → H2 (además del valor en Sheet). */
    var storesTotal =
      sheetTab === 'stores' ? this.getInvoiceOrderTotal() : 0;

    return fetch(promoApiUrl(base, 'api/promo/spin'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'omit',
      body: JSON.stringify({
        session_token: token,
        campaign_key: this.getLedgerCampaignKey(),
        sheet_tab: sheetTab,
        channel: sheetTab,
        invoice: orderId || undefined,
        order_id: orderId || undefined,
        order_name: orderId || undefined,
        order_total: storesTotal > 0 ? storesTotal : undefined
      })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || !data || data.error) {
          throw new Error((data && data.message) || MSG_LEDGER_SPIN_ERROR);
        }
        return data;
      });
    });
  };

  SpinWheel.prototype.requestLedgerFinalize = function (prize) {
    var self = this;
    if (!this.hasLedgerMode() || this._ledgerFinalized) {
      return Promise.resolve(null);
    }

    var base = this.getHydrogenBase();
    var token = this.getSessionToken();
    if (!base || !token) return Promise.resolve(null);

    var prizeKey =
      (prize && prize.prize_key) ||
      (isTryAgainPrize(prize) ? 'TRY_AGAIN' : '') ||
      (prize && prize.discount_code) ||
      '';

    this._ledgerFinalized = true;

    return fetch(promoApiUrl(base, 'api/promo/finalize'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'omit',
      body: JSON.stringify({
        session_token: token,
        campaign_key: this.getLedgerCampaignKey(),
        prize_key: prizeKey,
        sheet_tab: this.getLedgerSheetTab(),
        channel: this.getLedgerSheetTab()
      })
    })
      .then(function (res) {
        return res.json().catch(function () {
          return {};
        });
      })
      .catch(function () {
        self._ledgerFinalized = false;
        return null;
      });
  };

  SpinWheel.prototype.resolveLedgerPrize = function (serverPayload) {
    var idx = findPrizeIndexByKey(this.prizes, serverPayload && serverPayload.prize_key);
    if (idx < 0 && serverPayload && serverPayload.is_try_again) {
      for (var i = 0; i < this.prizes.length; i++) {
        if (isTryAgainPrize(this.prizes[i])) {
          idx = i;
          break;
        }
      }
    }
    if (idx < 0) idx = 0;
    return {
      index: idx,
      prize: mergeServerPrize(this.prizes[idx], serverPayload)
    };
  };

  SpinWheel.prototype.animateGame = function () {
    var self = this;

    /* Sin ledger, o landing tiendas sin session_token → pesos cliente. */
    if (!this.shouldUseLedgerSpin()) {
      if (this.gameType === 'slots') {
        return this.animateSlots();
      }
      return this.animateSpin();
    }

    /*
     * Ledger: girar YA; cuando /api/promo/spin responde, frenar en el premio.
     * Mínimo de espera visual para que no “pare” en 200ms.
     */
    var MIN_WAIT_MS = 1400;
    var startedAt = Date.now();
    var waiting = this.startWaitingSpin();

    return this.requestLedgerSpin()
      .then(function (payload) {
        var resolved = self.resolveLedgerPrize(payload);
        var elapsed = Date.now() - startedAt;
        var remain = Math.max(0, MIN_WAIT_MS - elapsed);

        return new Promise(function (resolve) {
          setTimeout(resolve, remain);
        }).then(function () {
          return waiting.stopOnPrize(resolved.index, resolved.prize);
        });
      })
      .catch(function (err) {
        return waiting.cancel().then(function () {
          throw err;
        });
      });
  };

  /** Giro continuo mientras llega el premio del ledger. */
  SpinWheel.prototype.startWaitingSpin = function () {
    var self = this;

    if (this.gameType === 'slots') {
      return this.startWaitingSlotsSpin();
    }
    return this.startWaitingWheelSpin();
  };

  SpinWheel.prototype._stopWaitingRaf = function () {
    if (this._waitingRafId) {
      cancelAnimationFrame(this._waitingRafId);
      this._waitingRafId = 0;
    }
  };

  /**
   * Giro continuo con rAF (no CSS): el transform inline de paintSlots
   * bloqueaba @keyframes y en "sigue intentando" quedaba pegado hasta /spin.
   */
  SpinWheel.prototype.startWaitingSlotsSpin = function () {
    var self = this;
    var slotsRoot = this.slotsEl;
    var n = this.prizes.length;
    var machine = slotsRoot && slotsRoot.querySelector('.spin-wheel-slots');
    var cancelled = false;
    var rafId = 0;
    var offset = 0;
    var lastTs = 0;
    var SPEED_PX_PER_MS = 0.9;
    var strips = [];
    var loopH = 0;

    this._stopWaitingRaf();

    if (slotsRoot && n >= 2) {
      paintSlots(slotsRoot, this.prizes);
      strips = Array.prototype.slice.call(
        slotsRoot.querySelectorAll('[data-spin-wheel-reel-strip]')
      );
      this.reelStrips = strips;
      loopH = Math.max(1, measureSlotCellHeight(strips[0]) * n);

      if (machine) {
        machine.classList.add('is-spinning', 'is-waiting');
      }
      if (typeof slotsRoot.scrollIntoView === 'function') {
        try {
          slotsRoot.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } catch (err) {
          /* ignore */
        }
      }

      var tick = function (ts) {
        if (cancelled) return;
        if (!lastTs) lastTs = ts;
        var dt = Math.min(48, ts - lastTs);
        lastTs = ts;
        offset = (offset + SPEED_PX_PER_MS * dt) % loopH;
        var y = -offset;
        for (var i = 0; i < strips.length; i++) {
          if (!strips[i]) continue;
          strips[i].style.transition = 'none';
          strips[i].style.animation = 'none';
          strips[i].style.transform = 'translate3d(0,' + y + 'px,0)';
        }
        rafId = requestAnimationFrame(tick);
        self._waitingRafId = rafId;
      };
      rafId = requestAnimationFrame(tick);
      this._waitingRafId = rafId;
    }

    function stopRaf() {
      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = 0;
      }
      self._waitingRafId = 0;
    }

    return {
      stopOnPrize: function (prizeIndex, prize) {
        if (cancelled) return Promise.resolve(prize);
        stopRaf();
        if (machine) machine.classList.remove('is-waiting');
        return self.animateSlots(prizeIndex, prize);
      },
      cancel: function () {
        cancelled = true;
        stopRaf();
        if (machine) {
          machine.classList.remove('is-spinning', 'is-waiting');
        }
        for (var i = 0; i < strips.length; i++) {
          if (strips[i]) {
            strips[i].style.animation = '';
            strips[i].style.transform = '';
          }
        }
        return Promise.resolve();
      }
    };
  };

  SpinWheel.prototype.startWaitingWheelSpin = function () {
    var self = this;
    var disc = this.disc;
    var cancelled = false;
    var rafId = 0;
    var lastTs = 0;
    var rot = this._currentRotation || 0;
    var SPEED_DEG_PER_MS = 0.65;

    this._stopWaitingRaf();

    if (disc) {
      disc.classList.add('is-spinning', 'is-waiting');
      disc.style.animation = 'none';
      disc.style.transition = 'none';
      var wrap = this.root.querySelector('.spin-wheel-modal__wheel-wrap') || disc;
      if (wrap && typeof wrap.scrollIntoView === 'function') {
        try {
          wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } catch (err) {
          /* ignore */
        }
      }

      var tick = function (ts) {
        if (cancelled) return;
        if (!lastTs) lastTs = ts;
        var dt = Math.min(48, ts - lastTs);
        lastTs = ts;
        rot = (rot + SPEED_DEG_PER_MS * dt) % 360;
        disc.style.transform = 'rotate(' + rot + 'deg)';
        rafId = requestAnimationFrame(tick);
        self._waitingRafId = rafId;
      };
      rafId = requestAnimationFrame(tick);
      this._waitingRafId = rafId;
    }

    function stopRaf() {
      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = 0;
      }
      self._waitingRafId = 0;
      self._currentRotation = rot;
    }

    return {
      stopOnPrize: function (prizeIndex, prize) {
        if (cancelled) return Promise.resolve(prize);
        stopRaf();
        if (disc) {
          disc.classList.remove('is-waiting');
          disc.style.animation = '';
        }
        return self.animateSpin(prizeIndex, prize);
      },
      cancel: function () {
        cancelled = true;
        stopRaf();
        if (disc) {
          disc.classList.remove('is-spinning', 'is-waiting');
          disc.style.animation = '';
          disc.style.transition = '';
        }
        return Promise.resolve();
      }
    };
  };

  SpinWheel.prototype.animateSlots = function (forcedIndex, forcedPrize) {
    var prizeIndex =
      typeof forcedIndex === 'number' && forcedIndex >= 0
        ? forcedIndex
        : pickWeightedIndex(this.prizes);
    var prize = forcedPrize || this.prizes[prizeIndex];
    var finalIndices = pickSlotsFinalIndices(this.prizes, prizeIndex);
    var slotsRoot = this.slotsEl;
    var n = this.prizes.length;

    if (!slotsRoot || n < 2) {
      return Promise.resolve(prize);
    }

    paintSlots(slotsRoot, this.prizes);
    this.reelStrips = Array.prototype.slice.call(
      slotsRoot.querySelectorAll('[data-spin-wheel-reel-strip]')
    );

    var machine = slotsRoot.querySelector('.spin-wheel-slots');
    if (machine) {
      machine.classList.remove('is-waiting');
      machine.style.removeProperty('--sw-slot-prize-count');
      machine.classList.add('is-spinning');
    }

    if (typeof slotsRoot.scrollIntoView === 'function') {
      try {
        slotsRoot.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (err) {
        try {
          slotsRoot.scrollIntoView(true);
        } catch (err2) {
          /* ignore */
        }
      }
    }

    var strips = this.reelStrips;
    var baseDuration = 2600;
    var stagger = 750;
    var tasks = [];
    for (var r = 0; r < strips.length; r++) {
      tasks.push(animateReelStrip(strips[r], finalIndices[r], n, baseDuration + r * stagger));
    }

    return Promise.all(tasks).then(function () {
      if (machine) machine.classList.remove('is-spinning');
      return prize;
    });
  };

  SpinWheel.prototype.animateSpin = function (forcedIndex, forcedPrize) {
    var prizeIndex =
      typeof forcedIndex === 'number' && forcedIndex >= 0
        ? forcedIndex
        : pickWeightedIndex(this.prizes);
    var prize = forcedPrize || this.prizes[prizeIndex];
    var from = this._currentRotation || 0;
    var delta = calcSpinRotation(prizeIndex, this.prizes);
    this._currentRotation = from + delta;
    var to = this._currentRotation;
    var duration = 4500;
    var disc = this.disc;

    if (!disc) {
      return Promise.resolve(prize);
    }

    var wrap = this.root.querySelector('.spin-wheel-modal__wheel-wrap') || disc;
    if (wrap && typeof wrap.scrollIntoView === 'function') {
      try {
        wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (err) {
        try {
          wrap.scrollIntoView(true);
        } catch (err2) {
          /* ignore */
        }
      }
    }

    disc.classList.remove('is-waiting');
    disc.style.animation = '';
    disc.classList.add('is-spinning');

    return new Promise(function (resolve) {
      var done = false;
      var finish = function () {
        if (done) return;
        done = true;
        disc.classList.remove('is-spinning', 'is-waiting');
        disc.style.transition = '';
        disc.style.animation = '';
        disc.style.transform = 'rotate(' + to + 'deg)';
        resolve(prize);
      };

      if (typeof disc.animate === 'function') {
        try {
          var anim = disc.animate(
            [
              { transform: 'rotate(' + from + 'deg)' },
              { transform: 'rotate(' + to + 'deg)' }
            ],
            {
              duration: duration,
              easing: 'cubic-bezier(0.17, 0.67, 0.12, 0.99)',
              fill: 'forwards'
            }
          );
          anim.onfinish = function () {
            try {
              anim.commitStyles();
              anim.cancel();
            } catch (e) {
              /* older Safari */
            }
            finish();
          };
          setTimeout(finish, duration + 250);
          return;
        } catch (err) {
          /* fallback CSS below */
        }
      }

      disc.style.transition = 'none';
      disc.style.transform = 'rotate(' + from + 'deg)';
      void disc.offsetWidth;
      disc.style.transition =
        'transform ' + duration + 'ms cubic-bezier(0.17, 0.67, 0.12, 0.99)';
      disc.style.transform = 'rotate(' + to + 'deg)';
      setTimeout(finish, duration + 100);
    });
  };

  SpinWheel.prototype.setGiftStatus = function (message, isError) {
    if (!this.giftStatusEl) return;
    if (!message) {
      this.giftStatusEl.hidden = true;
      this.giftStatusEl.textContent = '';
      this.giftStatusEl.classList.remove('is-error');
      return;
    }
    this.giftStatusEl.hidden = false;
    this.giftStatusEl.textContent = message;
    if (isError) this.giftStatusEl.classList.add('is-error');
    else this.giftStatusEl.classList.remove('is-error');
  };

  SpinWheel.prototype.fulfillGiftPrize = function (prize, options) {
    var self = this;
    var silent = options && options.silent;
    var variantId = giftVariantId(prize);
    var lockKey = 'gift:' + (variantId || 'x');

    this._giftLocks = this._giftLocks || {};
    if (this._giftLocks[lockKey]) {
      return this._giftLocks[lockKey];
    }

    if (!silent) this.setGiftStatus(MSG_GIFT_ADDING, false);

    this._giftLocks[lockKey] = this.addGiftToCart(prize)
      .then(function (cartResult) {
        if (!silent) {
          if (cartResult && cartResult.already) self.setGiftStatus(MSG_GIFT_ALREADY, false);
          else self.setGiftStatus(MSG_GIFT_ADDED, false);
        }
        return cartResult;
      })
      .catch(function (err) {
        if (!silent) self.setGiftStatus(MSG_GIFT_ERROR, true);
        try {
          console.warn('[spin-wheel] gift cart failed', err);
        } catch (e) {
          /* ignore */
        }
        return { ok: false };
      });

    return this._giftLocks[lockKey];
  };

  SpinWheel.prototype.refreshCartCount = function () {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) return null;
        return response.json();
      })
      .then(function (cart) {
        if (!cart) return null;
        var count = parseInt(cart.item_count, 10) || 0;
        var bubble =
          document.querySelector('[data-cart-count-bubble]') ||
          document.getElementById('CartCount');
        var countEl =
          document.querySelector('[data-cart-count]') ||
          document.getElementById('cart-count-header');

        if (bubble) {
          if (count > 0) {
            bubble.classList.remove('hide', 'critical-hidden');
            bubble.style.setProperty('display', 'flex', 'important');
          } else {
            bubble.classList.add('hide');
            bubble.style.removeProperty('display');
          }
        }
        if (countEl) countEl.textContent = String(count);

        try {
          document.dispatchEvent(
            new CustomEvent('cart:updated', { detail: { cart: cart } })
          );
        } catch (err) {
          /* ignore */
        }

        return cart;
      })
      .catch(function () {
        return null;
      });
  };

  function getGiftProperty(item) {
    if (!item || !item.properties) return '';
    var props = item.properties;
    return String(props[GIFT_LINE_PROPERTY] || props['_spin_wheel_gift'] || '').toLowerCase();
  }

  function collectGiftVariantIds() {
    var ids = {};
    document.querySelectorAll('[data-spin-wheel-prizes]').forEach(function (node) {
      try {
        var prizes = JSON.parse(node.textContent || '[]');
        for (var i = 0; i < prizes.length; i++) {
          var id = parseInt(prizes[i] && prizes[i].gift_variant_id, 10);
          if (!isNaN(id) && id > 0) ids[id] = true;
        }
      } catch (err) {
        /* ignore */
      }
    });
    return ids;
  }

  function isSpinWheelGiftLine(item, giftVariantIds) {
    if (!item) return false;
    if (getGiftProperty(item) === 'true' || getGiftProperty(item) === '1') return true;

    var vid = parseInt(item.variant_id, 10);
    if (isNaN(vid) || !giftVariantIds || !giftVariantIds[vid]) return false;

    // Fallback: variante de premio + sesión de ruleta (carritos previos sin property).
    try {
      if (sessionStorage.getItem(GIFT_SESSION_PREFIX + vid) === '1') return true;
    } catch (err) {
      /* ignore */
    }
    return false;
  }

  function analyzeGiftOnlyCart(cart, giftVariantIds) {
    var items = (cart && cart.items) || [];
    var hasGift = false;
    var hasOther = false;
    for (var i = 0; i < items.length; i++) {
      if (isSpinWheelGiftLine(items[i], giftVariantIds)) hasGift = true;
      else hasOther = true;
    }
    return {
      hasGift: hasGift,
      hasOther: hasOther,
      blocked: hasGift && !hasOther && items.length > 0
    };
  }

  SpinWheel.prototype.findGiftLineInCart = function (variantId) {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) return null;
        return response.json();
      })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          if (parseInt(item.variant_id, 10) !== variantId) continue;
          return { cart: cart, item: item };
        }
        return { cart: cart, item: null };
      })
      .catch(function () {
        return { cart: null, item: null };
      });
  };

  SpinWheel.prototype.addGiftToCart = function (prize) {
    var variantId = giftVariantId(prize);
    if (!variantId) return Promise.reject(new Error('missing_variant'));

    var sessionKey = GIFT_SESSION_PREFIX + variantId;
    var self = this;

    try {
      if (sessionStorage.getItem(sessionKey) === '1') {
        return this.findGiftLineInCart(variantId).then(function (found) {
          if (found.item) {
            return self.refreshCartCount().then(function () {
              return { ok: true, already: true };
            });
          }
          sessionStorage.removeItem(sessionKey);
          return self._postGiftToCart(prize, variantId, sessionKey);
        });
      }
    } catch (err) {
      /* private mode */
    }

    return this.findGiftLineInCart(variantId).then(function (found) {
      if (found.item) {
        try {
          sessionStorage.setItem(sessionKey, '1');
        } catch (e) {
          /* ignore */
        }
        return self.refreshCartCount().then(function () {
          return { ok: true, already: true };
        });
      }
      return self._postGiftToCart(prize, variantId, sessionKey);
    });
  };

  SpinWheel.prototype._postGiftToCart = function (prize, variantId, sessionKey) {
    var self = this;

    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: {
          _spin_wheel_gift: 'true'
        }
      })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            var msg =
              (data && (data.description || data.message)) || 'cart_add_failed';
            throw new Error(msg);
          }
          return data;
        });
      })
      .then(function (data) {
        try {
          sessionStorage.setItem(sessionKey, '1');
        } catch (e) {
          /* ignore */
        }
        return self.refreshCartCount().then(function () {
          return { ok: true, already: false, data: data };
        });
      });
  };

  SpinWheel.prototype.showResult = function (prize) {
    this.modal.classList.remove('is-spinning');
    this.modal.classList.add('is-result');

    if (this.formWrap) this.formWrap.hidden = true;
    if (this.resultEl) this.resultEl.hidden = false;

    var isGift = isGiftPrize(prize);
    var hasCode = hasDiscountCode(prize);
    var isLose = !isGift && !hasCode && isTryAgainPrize(prize);

    this.modal.classList.remove('is-try-again', 'is-gift');
    if (this.resultWinEl) this.resultWinEl.hidden = true;
    if (this.resultGiftEl) this.resultGiftEl.hidden = true;
    if (this.resultLoseEl) this.resultLoseEl.hidden = true;
    if (this.redemptionEl) {
      this.redemptionEl.hidden = true;
      this.redemptionEl.textContent = '';
    }
    if (this.tryAgainBtn) {
      this.tryAgainBtn.hidden = true;
      this.tryAgainBtn.disabled = true;
    }

    if (hasCode) {
      if (this.resultWinEl) this.resultWinEl.hidden = false;
      if (this.prizeLabelEl) this.prizeLabelEl.textContent = prize.label || '';
      if (isGift) this.fulfillGiftPrize(prize, { silent: true });

      if (this.shouldAssignUniqueCoupon(prize)) {
        /* Solo online: coupon_type del metaobjeto → código único vía H2 */
        if (this.codeWrapEl) this.codeWrapEl.hidden = false;
        if (this.copyBtn) {
          this.copyBtn.hidden = false;
          this.copyBtn.disabled = true;
        }
        if (this.codeEl) this.codeEl.textContent = MSG_COUPON_LOADING;
        var self = this;
        var couponType = this.getCouponType(prize);
        this.requestCustomerCoupon(prize)
          .then(function (uniqueCode) {
            prize.coupon_type = couponType;
            prize.discount_code = uniqueCode;
            if (self.codeEl) self.codeEl.textContent = uniqueCode;
            if (self.copyBtn) self.copyBtn.disabled = false;
          })
          .catch(function (err) {
            if (self.codeEl) self.codeEl.textContent = '—';
            if (self.copyBtn) self.copyBtn.disabled = true;
            if (self.formWrap) self.formWrap.hidden = false;
            self.showFormError((err && err.message) || MSG_COUPON_ASSIGN_ERROR);
          });
      } else if (this.isStoresChannel()) {
        /* Stores: sin cupón. redemption_note solo aquí (online no lo muestra). */
        if (this.codeWrapEl) this.codeWrapEl.hidden = true;
        if (this.copyBtn) this.copyBtn.hidden = true;
        if (this.codeEl) this.codeEl.textContent = '';
        if (this.redemptionEl && this.isStoresChannel()) {
          var note = String((prize && prize.redemption_note) || '').trim();
          if (!note) {
            note = this.root.dataset.storesRedemptionNote || '';
          }
          if (!note) {
            note = this.getSessionToken()
              ? 'Presenta este premio en tienda para reclamarlo. Quedó registrado con tu factura.'
              : 'Presenta este premio en tienda para reclamarlo.';
          }
          this.redemptionEl.textContent = note;
          this.redemptionEl.hidden = false;
        }
      } else if (this.codeEl) {
        if (this.codeWrapEl) this.codeWrapEl.hidden = false;
        this.codeEl.textContent = prize.discount_code || '—';
      }
    } else if (isGift) {
      this.modal.classList.add('is-gift');
      if (this.resultGiftEl) this.resultGiftEl.hidden = false;

      var giftLabel = prize.gift_title || prize.label || '';
      if (this.giftPrizeLabelEl) this.giftPrizeLabelEl.textContent = giftLabel;

      if (this.viewCartBtn) {
        var cartUrl = this.root.dataset.cartUrl || '/cart';
        this.viewCartBtn.setAttribute('href', cartUrl);
        var cartLabel = this.root.dataset.viewCartLabel;
        if (cartLabel) this.viewCartBtn.textContent = cartLabel;
      }

      this.fulfillGiftPrize(prize);
    } else if (isLose) {
      this.modal.classList.add('is-try-again');
      if (this.resultLoseEl) this.resultLoseEl.hidden = false;
      if (this.losePrizeLabelEl) this.losePrizeLabelEl.textContent = prize.label || '';

      var canRetry = canSpinAgain(this.root);
      if (this.tryAgainBtn) {
        this.tryAgainBtn.hidden = !canRetry;
        this.tryAgainBtn.disabled = !canRetry;
        if (canRetry) {
          this.tryAgainBtn.textContent =
            this.root.dataset.tryAgainLabel || 'Intentar de nuevo';
        }
      }
    } else {
      if (this.resultWinEl) this.resultWinEl.hidden = false;
      if (this.codeEl) this.codeEl.textContent = prize.discount_code || '—';
      if (this.prizeLabelEl) this.prizeLabelEl.textContent = prize.label || '';
    }

    if (!canSpinAgain(this.root)) {
      this.setFloatingVisible(false);
    }

    if (isRealPrize(prize)) {
      this.startCountdown();
    }

    if (this.shouldUseLedgerSpin()) {
      var shouldFinalize = isRealPrize(prize) || !canSpinAgain(this.root);
      if (shouldFinalize) {
        this.requestLedgerFinalize(
          isRealPrize(prize) ? prize : mergeServerPrize(prize, { prize_key: 'TRY_AGAIN', is_try_again: true })
        );
      }
    }
  };

  SpinWheel.prototype.isCountdownEnabled = function () {
    return this.root.dataset.countdownEnabled === 'true' && !!this.countdownEl;
  };

  SpinWheel.prototype.getCountdownDurationMs = function () {
    var sec = parseInt(this.root.dataset.countdownDuration, 10);
    if (isNaN(sec) || sec < 1) return 0;
    return sec * 1000;
  };

  SpinWheel.prototype.stopCountdownTicker = function () {
    if (this._countdownTimer) {
      clearInterval(this._countdownTimer);
      this._countdownTimer = null;
    }
  };

  SpinWheel.prototype.hideCountdown = function () {
    this.stopCountdownTicker();
    if (this.countdownEl) {
      this.countdownEl.hidden = true;
      this.countdownEl.classList.remove('is-expired');
    }
  };

  SpinWheel.prototype.clearCountdown = function () {
    this.hideCountdown();
    clearCountdownState(this.root.dataset.campaignId);
  };

  SpinWheel.prototype.renderCountdownTick = function (endsAt) {
    if (!this.countdownEl || !this.countdownTimeEl) return false;

    var now = Date.now();
    var left = endsAt - now;
    var format = this.root.dataset.countdownFormat || 'mm:ss';

    if (left <= 0) {
      var expiredLabel =
        this.root.dataset.countdownExpiredLabel || 'Oferta expirada';
      if (this.countdownLabelEl) this.countdownLabelEl.textContent = expiredLabel;
      this.countdownTimeEl.textContent = formatCountdown(0, format);
      this.countdownEl.classList.add('is-expired');
      this.countdownEl.hidden = false;
      this.stopCountdownTicker();
      clearCountdownState(this.root.dataset.campaignId);
      var self = this;
      setTimeout(function () {
        self.hideCountdown();
      }, 4000);
      return false;
    }

    this.countdownEl.classList.remove('is-expired');
    this.countdownTimeEl.textContent = formatCountdown(left, format);
    this.countdownEl.hidden = false;
    return true;
  };

  SpinWheel.prototype.startCountdownTicker = function (endsAt) {
    var self = this;
    this.stopCountdownTicker();
    if (!this.renderCountdownTick(endsAt)) return;
    this._countdownTimer = setInterval(function () {
      if (!self.renderCountdownTick(endsAt)) {
        self.stopCountdownTicker();
      }
    }, 250);
  };

  SpinWheel.prototype.startCountdown = function () {
    if (!this.isCountdownEnabled()) return;

    var durationMs = this.getCountdownDurationMs();
    if (durationMs < 1) return;

    var now = Date.now();
    var state = {
      startedAt: now,
      endsAt: now + durationMs
    };
    writeCountdownState(this.root.dataset.campaignId, state);

    var label = this.root.dataset.countdownLabel || 'Tu oferta expira en';
    if (this.countdownLabelEl) this.countdownLabelEl.textContent = label;

    this.startCountdownTicker(state.endsAt);
  };

  SpinWheel.prototype.restoreCountdown = function () {
    if (!this.isCountdownEnabled()) return;

    var state = readCountdownState(this.root.dataset.campaignId);
    if (!state || !state.endsAt) {
      this.hideCountdown();
      return;
    }

    if (state.endsAt <= Date.now()) {
      this.clearCountdown();
      return;
    }

    var label = this.root.dataset.countdownLabel || 'Tu oferta expira en';
    if (this.countdownLabelEl) this.countdownLabelEl.textContent = label;
    this.startCountdownTicker(state.endsAt);
  };

  SpinWheel.prototype.handleTryAgain = function () {
    if (this._retrySpinning) return;
    if (!canSpinAgain(this.root)) {
      if (this.tryAgainBtn) this.tryAgainBtn.hidden = true;
      return;
    }

    var self = this;
    this._retrySpinning = true;

    if (this.resultEl) this.resultEl.hidden = true;
    if (this.tryAgainBtn) {
      this.tryAgainBtn.hidden = true;
      this.tryAgainBtn.disabled = true;
    }

    /* Mostrar rueda/slots YA (is-result los oculta) y forzar layout antes del fetch. */
    this.modal.classList.remove('is-result', 'is-try-again', 'is-gift');
    this.modal.classList.add('is-spinning');
    if (this.formWrap) this.formWrap.hidden = true;
    void this.modal.offsetHeight;

    this.animateGame()
      .then(function (prize) {
        incrementSpinCount(self.root);
        self._retrySpinning = false;
        self.showResult(prize);
      })
      .catch(function (err) {
        self._retrySpinning = false;
        self._stopWaitingRaf();
        self.modal.classList.remove('is-spinning');
        if (self.resultEl) self.resultEl.hidden = false;
        if (self.tryAgainBtn && canSpinAgain(self.root)) {
          self.tryAgainBtn.hidden = false;
          self.tryAgainBtn.disabled = false;
        }
        self.showFormError((err && err.message) || MSG_LEDGER_SPIN_ERROR);
      });
  };

  function pageHasInvoiceForm() {
    return !!document.querySelector('[data-rf-form]');
  }

  function findSpinWheelInstance(opts) {
    opts = opts || {};
    var nodes = document.querySelectorAll('[data-spin-wheel-root]');
    var preferred = null;
    for (var i = 0; i < nodes.length; i++) {
      var root = nodes[i];
      var inst = root._kronoSpinWheel;
      if (!inst) continue;
      if (opts.ledgerOnly && !inst.hasLedgerMode()) continue;
      if (
        opts.campaignKey &&
        inst.getLedgerCampaignKey() &&
        inst.getLedgerCampaignKey() !== String(opts.campaignKey)
      ) {
        continue;
      }
      if (inst.hasLedgerMode()) return inst;
      if (!preferred) preferred = inst;
    }
    return preferred;
  }

  /**
   * Abre la ruleta tras registro de factura (ledger).
   * Si hay session_token, arranca el giro sin pedir de nuevo el form de email.
   * opts.email: autorellena el input (email del form de facturas).
   */
  function openAfterInvoice(opts) {
    opts = opts || {};
    var inst = findSpinWheelInstance({
      ledgerOnly: true,
      campaignKey: opts.campaignKey || opts.campaign_key
    });
    if (!inst) inst = findSpinWheelInstance({});
    if (!inst) return false;

    var campaignId =
      opts.campaignId ||
      inst.root.dataset.campaignId ||
      inst.getLedgerCampaignKey() ||
      'default';
    if (opts.sessionToken) {
      writeSessionToken(campaignId, opts.sessionToken);
      writeSessionToken(inst.root.dataset.campaignHandle, opts.sessionToken);
      writeSessionToken(inst.getLedgerCampaignKey(), opts.sessionToken);
      writeSessionToken('default', opts.sessionToken);
    }

    if (opts.orderId) {
      inst.setInvoiceOrderId(opts.orderId);
    }

    if (opts.orderTotal != null || opts.order_total != null) {
      inst.setInvoiceOrderTotal(
        opts.orderTotal != null ? opts.orderTotal : opts.order_total
      );
    }

    /* Canal del form de facturas: debe coincidir con la pestaña donde se guardó la sesión. */
    var invoiceChannel = String(opts.channel || opts.sheet_tab || '')
      .trim()
      .toLowerCase();
    if (invoiceChannel === 'online' || invoiceChannel === 'stores') {
      inst.setLedgerSheetTabOverride(invoiceChannel);
    }

    /*
     * Stores: el asesor usa el mismo tablet. Sin reset, localStorage.spin-count
     * bloquea al cliente siguiente. Cada registro (nuevo session_token) reinicia
     * el contador del browser; Apps Script sigue limitando por sesión.
     */
    if (invoiceChannel === 'stores') {
      resetClientSpinBudget(inst.root);
      inst.hasSpunThisSession = false;
      inst._retrySpinning = false;
      inst._ledgerFinalized = false;
    }

    if (inst.form) {
      var email = String(opts.email || '').trim();
      if (email) {
        var emailInput =
          inst.form.querySelector('[data-spin-wheel-email]') ||
          inst.form.querySelector('input[type="email"][name="contact[email]"]') ||
          inst.form.querySelector('input[type="email"]');
        if (emailInput) emailInput.value = email;
      }

      /* Ya aceptó datos en el form de facturas: marcar privacidad de la ruleta. */
      if (opts.privacyAccepted) {
        var privacyInput =
          inst.form.querySelector('[data-spin-wheel-privacy]') ||
          inst.form.querySelector('input[type="checkbox"][name*="datos"]') ||
          inst.form.querySelector('.spin-wheel-field--privacy input[type="checkbox"]');
        if (privacyInput) privacyInput.checked = true;
      }

    }

    inst.open(true);

    /* Prefill no dispara input/change: activar CTA si el form ya es válido. */
    if (typeof inst.updateSpinButtonState === 'function') {
      inst.updateSpinButtonState();
    }

    var invoiceEmail = sanitizeEmailClient(opts.email);

    function startLedgerSpin() {
      if (!(inst.hasLedgerMode() && inst.getSessionToken())) return;
      if (inst.formWrap) inst.formWrap.hidden = true;
      if (inst.resultEl) inst.resultEl.hidden = true;
      if (inst.spinBtn) {
        inst.spinBtn.disabled = true;
        inst.spinBtn.textContent = MSG_SPINNING;
      }
      inst.modal.classList.add('is-spinning');
      inst.hasSpunThisSession = true;
      inst
        .animateGame()
        .then(function (prize) {
          incrementSpinCount(inst.root);
          inst.showResult(prize);
        })
        .catch(function (err) {
          inst.modal.classList.remove('is-spinning');
          if (inst.formWrap) inst.formWrap.hidden = false;
          inst.showFormError((err && err.message) || MSG_LEDGER_SPIN_ERROR);
          if (inst.spinBtn) inst.spinBtn.textContent = inst.getSpinLabel();
          if (typeof inst.updateSpinButtonState === 'function') {
            inst.updateSpinButtonState();
          }
        });
    }

    /* Tras factura: suscriptor vía H2 (stores crea si hace falta; online solo tags si ya suscrito). */
    if (invoiceEmail && inst.getHydrogenBase()) {
      inst
        .tryHydrogenSubscribePath(invoiceEmail)
        .then(function (result) {
          if (result && result.usedHydrogen) {
            startLedgerSpin();
            return;
          }
          /* Online sin suscripción H2: igual gira (form ruleta no aplica post-factura). */
          if (!inst.isStoresChannel()) {
            startLedgerSpin();
            return;
          }
          /* Stores sin H2/subscriber: no girar (evitar challenge form). */
          if (inst.formWrap) inst.formWrap.hidden = false;
          inst.showFormError(MSG_TAG_CAMPAIGN_ERROR);
        })
        .catch(function (err) {
          if (inst.formWrap) inst.formWrap.hidden = false;
          inst.showFormError((err && err.message) || MSG_TAG_CAMPAIGN_ERROR);
          if (typeof inst.updateSpinButtonState === 'function') {
            inst.updateSpinButtonState();
          }
        });
    } else {
      startLedgerSpin();
    }

    return true;
  }

  /** Expone helper para el form de facturas / otras landings. */
  window.KronoSpinWheelSession = {
    write: writeSessionToken,
    read: readSessionToken
  };

  window.KronoSpinWheel = {
    openAfterInvoice: openAfterInvoice,
    find: findSpinWheelInstance
  };

  SpinWheel.prototype.copyCode = function () {
    var code = this.codeEl ? this.codeEl.textContent : '';
    if (!code) return;

    var self = this;
    var onCopied = function () {
      self.copyBtn.classList.add('is-copied');
      var original = self.copyBtn.textContent;
      self.copyBtn.textContent = MSG_COPIED;
      setTimeout(function () {
        self.copyBtn.classList.remove('is-copied');
        self.copyBtn.textContent = original;
      }, 2000);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(onCopied);
    } else {
      var ta = document.createElement('textarea');
      ta.value = code;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      onCopied();
    }
  };

  function showGiftOnlyCheckoutMessage() {
    var cartError = document.querySelector('[data-cart-error-message]');
    var cartErrorWrap = document.querySelector('[data-cart-error-message-wrapper]');
    if (cartError && cartErrorWrap) {
      cartError.textContent = MSG_GIFT_ONLY_CHECKOUT;
      cartErrorWrap.classList.remove('hide');
      try {
        cartErrorWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (err) {
        /* ignore */
      }
      return;
    }

    var banner = document.querySelector('[data-spin-wheel-gift-only-msg]');
    if (banner) {
      banner.hidden = false;
      try {
        banner.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (err2) {
        /* ignore */
      }
      return;
    }

    window.alert(MSG_GIFT_ONLY_CHECKOUT);
  }

  function applyGiftOnlyCheckoutUi(blocked, cartEmpty) {
    var nodes = document.querySelectorAll(
      '[data-spin-wheel-checkout-guard], .btnCheckoutCart, button-checkout, button-checkout-page-product, a[href="/checkout"]'
    );
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (blocked || cartEmpty) {
        el.setAttribute('aria-disabled', 'true');
        if (blocked) el.classList.add('is-spin-wheel-gift-blocked');
        if ('disabled' in el) el.disabled = true;
      } else {
        el.removeAttribute('aria-disabled');
        el.classList.remove('is-spin-wheel-gift-blocked');
        if ('disabled' in el) el.disabled = false;
      }
    }

    var banner = document.querySelector('[data-spin-wheel-gift-only-msg]');
    if (banner) banner.hidden = !blocked;

    var extra = document.querySelector('.additional-checkout-buttons');
    if (extra) extra.style.display = blocked ? 'none' : '';
  }

  function setupGiftOnlyCheckoutGuard() {
    var giftVariantIds = collectGiftVariantIds();
    var cachedBlocked = null;
    var checking = false;

    function refreshFromCart() {
      return fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then(function (response) {
          if (!response.ok) return null;
          return response.json();
        })
        .then(function (cart) {
          if (!cart) return false;
          var analysis = analyzeGiftOnlyCart(cart, giftVariantIds);
          cachedBlocked = analysis.blocked;
          applyGiftOnlyCheckoutUi(analysis.blocked, !(cart.item_count > 0));
          return analysis.blocked;
        })
        .catch(function () {
          return false;
        });
    }

    function isCheckoutTrigger(el) {
      if (!el || !el.closest) return null;
      return (
        el.closest('[data-spin-wheel-checkout-guard]') ||
        el.closest('button-checkout') ||
        el.closest('button-checkout-page-product') ||
        el.closest('button-summary-checkout') ||
        el.closest('.btnCheckoutCart') ||
        el.closest('a[href="/checkout"]') ||
        el.closest('a[href*="/checkouts/"]') ||
        el.closest('input[name="checkout"]') ||
        el.closest('button[name="checkout"]')
      );
    }

    function proceedCheckout(trigger) {
      if (!trigger) return;
      trigger.dataset.spinWheelCheckoutBypass = '1';
      try {
        if (trigger.tagName === 'A' && trigger.getAttribute('href')) {
          window.location.href = trigger.href;
          return;
        }
        if (typeof trigger.click === 'function') {
          trigger.click();
        }
      } finally {
        delete trigger.dataset.spinWheelCheckoutBypass;
      }
    }

    document.addEventListener(
      'click',
      function (event) {
        var trigger = isCheckoutTrigger(event.target);
        if (!trigger) return;
        if (trigger.dataset && trigger.dataset.spinWheelCheckoutBypass === '1') return;

        if (cachedBlocked === false) return;

        if (cachedBlocked === true) {
          event.preventDefault();
          event.stopPropagation();
          if (event.stopImmediatePropagation) event.stopImmediatePropagation();
          showGiftOnlyCheckoutMessage();
          return;
        }

        // Aún no sabemos: validar antes de dejar pasar.
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        if (checking) return;
        checking = true;

        refreshFromCart()
          .then(function (blocked) {
            if (blocked) {
              showGiftOnlyCheckoutMessage();
              return;
            }
            proceedCheckout(trigger);
          })
          .finally(function () {
            checking = false;
          });
      },
      true
    );

    document.addEventListener('cart:updated', function () {
      refreshFromCart();
    });

    refreshFromCart();
  }

  function init() {
    if (window.__kronoSpinWheelCountdownCleared) {
      clearAllCountdownStates();
    }

    document.querySelectorAll('[data-spin-wheel-root]').forEach(function (root) {
      new SpinWheel(root);
    });
    setupGiftOnlyCheckoutGuard();
  }

  window.KronoSpinWheelClearCountdowns = clearAllCountdownStates;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();